import axios from "axios";
// import { Swiper, SwiperSlide } from "swiper/react";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import useEmblaCarousel from "embla-carousel-react";
import { components } from "../components";
// import logo from "../../assets/nestfin/NexfinPng.png"
import logo from "../assets/nestfin/Nestfin_logo.png";
import { BottomTabBar } from "../navigation/BottomTabBar";
import { text } from "../text";
import { hooks } from "../hooks";
import roomAvailable from "../assets/nestfin/deadline.png";
import cash from "../assets/nestfin/cash.png";
import { PropertyRoomType, Feature } from "../../src/types/types";

import {
  formatIndianNumber,
  getRoomOptionsById,
  propertyTanantAdd,
  propertyTanantAgreementDetails,
  propertyTanantBooking,
  updateLeadProfile,
  viewLeadProfile,
  webCallLead,
} from "../environment";
import useApi from "../customHook/useApi";

import { toast } from "react-toastify";
import { callService } from "../customHook/callService";
import { theme } from "../constants";
import { CustomLoader } from "../components/CustomLoader";
import ContactOwnerModal from "../components/ContactOwnerModal";

export interface APIResponse {
  success: boolean;
  statusCode: number;
  data: PropertyRoomType[];
  message: string;
}

export interface profileResponse {
  success: boolean;
  statusCode: number;
  message: string;
  tenant_id?: string;
}

// view profile data

type Profile = {
  full_name: string | null;
  email: string | null;
  phone_number: string | null;
  gender: string | null;
  dob: string | null;
  pref_budget_min_range: number | null;
  pref_budget_max_range: number | null;
  pref_city_name: string | null;
  pref_city_id: number | null;
  pref_locality_id: number | null;
};

export interface profileResponse {
  success: boolean;
  statusCode: number;
  data: Profile;
  // message?: string;
}

export const RoomDetails: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [isModalOpen3, setIsModalOpen3] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [selectedTab, setSelectedTab] = React.useState("All");
  const location = useLocation();
  const propertyData = location.state?.propertyData;

  // console.log(propertyData, "propertyData.....");

  const navigate = hooks.useNavigate();
  const [selectedRoomType, setSelectedRoomType] = useState("");
  const [roomType, setRoomType] = useState<PropertyRoomType[]>([]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // API CALL for room details
  const {
    data: propertyRoomDetailData,
    loading: propertyRoomDetailLoading,
    callApi: fetchPropertyRoomDetail,
  } = useApi<APIResponse>(getRoomOptionsById, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  useEffect(() => {
    const leadId = localStorage.getItem("lead_profile_id") ?? "";
    // console.log(location.state, "location vikas kumar");
    const propertyId = localStorage.getItem("property_id");
    // const propertyId = location.state.property_id
    fetchPropertyRoomDetail({
      leadId: leadId,
      propertyId: propertyId,
      // leadId: "LEAD-B-2025-05-001",
      // propertyId: "PR-G-2025-05-072",
    });
  }, [location.state]);

  useEffect(() => {
    if (propertyRoomDetailData?.data) {
      const roomData = propertyRoomDetailData.data;

      setFormData((prev) => ({
        ...prev,
        property_id: roomData[0].property_id ?? "",
        property_room_option_id: roomData[0].property_room_option_id ?? "",
        room_type_id: roomData[0].room_type_id ?? "",
      }));

      setRoomType(propertyRoomDetailData?.data);
    }
  }, [propertyRoomDetailData]);

  // handle pop form
  interface UserFormData {
    fullName: string;
    gender: string;
    country_code: string;
    contact_number: string;
    is_b2b_user: string;
    occupation: string;
    email: string;
    property_id: string;
    property_room_option_id: string;
    room_type_id: string;
    lead_profile_id: string;
  }

  const [formData, setFormData] = useState<UserFormData>({
    fullName: "",
    gender: "",
    country_code: "91",
    contact_number: "",
    is_b2b_user: "No",
    occupation: "",
    email: "",
    property_id: "",
    property_room_option_id: "",
    room_type_id: "",
    lead_profile_id: localStorage.getItem("lead_profile_id") ?? "",
  });

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [isShowContactModal, setIsShowContactModal] = useState<boolean>(false);
  const [selectedProperty, setSelectedProperty] = useState<any>(null);
  // const [selectedPropertyId,] = useState<any>(null);

  const validateForm = (): string | null => {
    if (!formData.fullName?.trim()) {
      return "Full Name is required";
    } else if (formData.fullName.trim().length < 3) {
      return "Full Name must be at least 3 characters";
    } else if (formData.fullName.trim().length > 15) {
      return "Full Name must not exceed 15 characters";
    }

    if (!formData.gender) {
      return "Please select your gender";
    }

    if (!formData.contact_number?.trim()) {
      return "Contact Number is required";
    } else if (!/^\d{10}$/.test(formData.contact_number)) {
      return "Contact Number must be exactly 10 digits";
    }

    if (!formData.email?.trim()) {
      return "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      return "Enter a valid email";
    }

    if (!formData.occupation) {
      return "Occupation is required";
    }

    if (!formData.is_b2b_user) {
      return "Please select B2B user type";
    }

    return null; // ✅ All fields are valid
  };

  // API CALL FOR /view-lead-profile
  const {
    data: profileData,
    loading: profileLoading,
    callApi: fetchProfile,
  } = useApi<profileResponse>(viewLeadProfile, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  // 1. API Call Trigger (on mount)
  useEffect(() => {
    const leadId = localStorage.getItem("lead_profile_id") ?? "";
    if (leadId) {
      fetchProfile({ leadId });
    }
  }, []);

  useEffect(() => {
    if (profileData?.data) {
      const data = profileData.data;

      setFormData((prev) => ({
        ...prev,
        fullName: data.full_name ?? "",
        gender: data.gender ?? "",
        contact_number: data.phone_number ?? "",
        email: data.email ?? "",
      }));
    }
  }, [profileData]);

  // API CALL FOR UPDATE DATA
  const {
    data: UpdateProfileData,
    loading: UpdateProfileLoading,
    callApi: updatePayload,
  } = useApi<profileResponse>(updateLeadProfile, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  useEffect(() => {
    if (UpdateProfileData?.success) {
      console.log("Profile updated successfully");
    }
  }, [UpdateProfileData]);

  // useEffect(() => {
  //     const leadId = localStorage.getItem("lead_profile_id");

  //     const updatedPayload = {
  //         leadId: leadId,
  //         full_name: profileData?.data?.full_name,
  //         email: profileData?.data?.email,
  //         phone_number: profileData?.data?.phone_number,
  //         gender: genderAPI,
  //         dob: profileData?.data?.dob,
  //         pref_budget_min_range: String(minAmountStr),
  //         pref_budget_max_range: String(maxAmountStr),
  //         pref_city_id: cityId,
  //         pref_locality_id: id[0],
  //     };

  //     console.log("Merged update payload:", updatedPayload);
  //     updatePayload(updatedPayload);
  // }, []);

  // api calling for submit data

  // API CALL
  const {
    data: submitResponse,
    loading: submitLoading,
    callApi: submitTenant,
  } = useApi<any>(propertyTanantAdd, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  //2nd api call

  const {
    data: PropertyAllotedResponse,
    loading: PropertyAllotedLoading,
    callApi: propertyBooking,
  } = useApi<any>(propertyTanantBooking, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  // 3rd api

  const [isModalOpenDate, setIsModalOpenDate] = useState(false);
  const [agreementDate, setAgreementDate] = useState("");
  const [isRequestSent, setIsRequestSent] = useState(false);

  const {
    data: AgreementAllotedResponse,
    loading: AgreementAllotedLoading,
    callApi: allotAgreement,
  } = useApi<any>(propertyTanantAgreementDetails, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });
  // Web Call Api
  const {
    data: WebCallApiData,
    loading: WebCallApiLoading,
    callApi: webCallPost,
  } = useApi(webCallLead, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  const handleUpdateProfile = () => {
    const leadId = localStorage.getItem("lead_profile_id") ?? "";

    const updatedPayload = {
      leadId: leadId,
      full_name: formData.fullName, // override with form input
      email: formData.email,
      phone_number: formData.contact_number,
      gender: formData.gender,
      dob: profileData?.data?.dob,
      pref_budget_min_range: profileData?.data?.pref_budget_min_range,
      pref_budget_max_range: profileData?.data?.pref_budget_max_range,
      pref_city_id: profileData?.data?.pref_city_id,
      pref_locality_id: profileData?.data?.pref_locality_id, // from locality selection
    };

    // console.log("Final update profile payload:", updatedPayload);
    updatePayload(updatedPayload);
  };

  const handleSubmitTenant = async () => {
    const errorMessage = validateForm();
    if (errorMessage) {
      toast.error(errorMessage);
      return;
    }

    try {
      const payload = { ...formData };

      const tenantResponse = await submitTenant(formData); // callApi from useApi
      // console.log("API Response:", tenantResponse);

      if (tenantResponse?.success) {
        const tenant_id = tenantResponse.tenant_id;
        localStorage.setItem("tenant_id", tenant_id);
        // toast.success(tenantResponse.message);

        // ✅ Get property_id from localStorage
        // const property_id = localStorage.getItem("property_id");

        const property_id = localStorage.getItem("property_id");

        if (!property_id) {
          toast.error("Property ID is required");
          return;
        }

        // Call 2nd Api
        const bookingPayload = {
          tenant_id,
          property_id,
        };

        const bookingResponse = await propertyBooking(bookingPayload);
        // console.log(bookingResponse);
        if (bookingResponse?.success) {
          localStorage.setItem("booking_id", bookingResponse?.bookingId);
          //   localStorage.setItem("tenant_id", bookingResponse?.tenant_id);
          // toast.success(bookingResponse?.message);

          // toast.success(bookingResponse?.message || "Property allotted successfully");

          // ✅ Update profile here
          handleUpdateProfile(); // 👈 call the merged update API

          // ✅ Now open date modal to allow agreement step (step 3)
          setIsModalOpen(false);
          setIsModalOpenDate(true);
        } else {
          toast.error("Property allotment failed");
        }
        // ✅ Clear the form data
        // setFormData({
        //   fullName: "",
        //   gender: "",
        //   country_code: "91",
        //   contact_number: "",
        //   is_b2b_user: "",
        //   occupation: "",
        //   email: "",
        //   //   property_id: "",
        // });

        // after these proecess then show pop with date picker  so user pick the date and then call 3rd api
      } else {
        toast.error("Tenant creation failed");
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error("Something went wrong");
    }
  };

  // handleAgreementSubmit
  const handleAgreementSubmit = async (agreementDate: string) => {
    const tenant_id = localStorage.getItem("tenant_id");
    const property_id = localStorage.getItem("property_id");
    const bookingId = localStorage.getItem("booking_id");

    if (!tenant_id || !property_id || !bookingId || !agreementDate) {
      toast.error("Missing data for agreement allocation");
      return;
    }

    const unit_rent = roomType[0].unit_rent;

    // Extract the number part from "2 Months"
    const months = parseInt(roomType[0].security_deposit_months); // This will give you 2
    // console.log(months, "security");

    // Calculate security deposit
    const se_deposit = unit_rent * months;
    // console.log(months, "security");
    // console.log(se_deposit, "security");

    const noticeperiod_duration = `${
      parseInt(roomType[0].noticeperiod_months) * 30
    } Days`;

    const payload = {
      tenant_id,
      property_id,
      booking_id: bookingId,
      movein_date: agreementDate,
      //   renttype_enum_id: "RENTAL_TYPE_1M",
      //   rent_amount: roomType[0].unit_rent,
      //   mentinance_amount: "500",
      //   security_deposit_amt: se_deposit,
      //   agreement_start_date: agreementDate,
      //   tanant_move_in_date: agreementDate,
      //   rent_cycle_enum_id: "PMS_RENTAL_CYCLE_DATE_1",
      //   agreement_duration_month: roomType[0].agreement_duration_months,
      //   lockin_duration_month: roomType[0].lockinperiod_months,
      //   noticeperiod_duration_month: "10 Days",
      // noticeperiod_duration_month: noticeperiod_duration,
    };
    try {
      const res = await allotAgreement(payload);
      if (res?.success) {
        setConfirmModal(true);
        // toast.success("Vikas kumar");
        setIsModalOpenDate(false); // Close date modal
        setAgreementDate("");
      } else {
        toast.error("Failed to allocate agreement");
      }
    } catch (err) {
      console.error(err);
      toast.error("Agreement API failed");
    }
  };

  const callLeadServiceAPI = async () => {
    try {
      const leadId = localStorage.getItem("lead_profile_id") ?? "";
      if (!leadId) return;

      const response = await callService("PAID_BOOKING");
    } catch (error) {
      console.error("Error while calling PAID_BOOKING API", error);
    }
  };

  //         const payload = {
  //     tenant_id,
  //     property_id,
  //     bookingId,
  //     renttype_enum_id: "RENTAL_TYPE_1M",
  //     rent_amount: "15000",
  //     mentinance_amount: "500",
  //     security_deposit_amt: "15000",
  //     agreement_start_date: agreementDate,
  //     tanant_move_in_date: agreementDate,
  //     rent_cycle_enum_id: "PMS_RENTAL_CYCLE_DATE_1",
  //     agreement_duration_month: "2 Months",
  //     lockin_duration_month: "6 Months",
  //     noticeperiod_duration_month: "10 Days",
  // };

  const getTomorrowDate = () => {
    const today = new Date();
    today.setDate(today.getDate()); // move to next day
    return today.toISOString().split("T")[0]; // format as YYYY-MM-DD
  };

  // web call leadws
  // const handleWebCallLead = async (propertyId: any, prefs: any) => {
  const handleWebCallLead = async (prefs: any) => {
    // console.log(propertyId, "Click Button");_
    if (!selectedProperty?.property_id) return;
    const leadId = localStorage.getItem("lead_profile_id") ?? "";
    const payload = {
      property_id: selectedProperty?.property_id,
      lead_id: leadId,
      ...prefs,
      // lead_id: leadIdFromStorage,
    };
    try {
      const response = await webCallPost(payload);
      console.log("API Response:", response);
      if (response.success) {
        setIsShowContactModal(false);
        setSelectedProperty(null);

        setIsModalOpen2(true);
      }
    } catch (error) {
      console.error("API call failed:", error);
    }
  };

  const handleRequestCallback = async (room: any) => {
    // console.log("Code Call");

    try {
      const payload = [
        { param: "PROPERTY_ID", value: room?.property_id },
        { param: "ROOM_TYPE_ID", value: room?.room_type_id },
        { param: "PROPERTY_NAME", value: room?.property_name },
        { param: "ROOM", value: room?.room_type_name },
      ];

      // const response = await callService("REQUEST_CALLBACK");
      const response = await callService("SENT_INQUIRY", payload);
      // console.log("✅ SENT_INQUIRY success:", response);

      // console.log("room data", room);
      // const payload = [
      //   { param: "NAME", value: formData?.full_name },
      //   { param: "EMAIL", value: formData?.email },
      //   { param: "MESSAGE", value: formData?.message },
      // ];

      // Open modal or show confirmation
      // setIsModalOpen2(true);
    } catch (error) {
      setIsModalOpen3(true);
      console.error("❌ SENT_INQUIRY failed:", error);
    }
  };

  // Start Component
  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        goBack={false}
        line={false}
        leftlogo={true}
        rightlogo={false}
        // search={true}
        filter={false}
        // logo={true}
        title={""}
        centerImageSrc={logo}
      />
    );
  };

  const renderBottomTabBar = (): JSX.Element => {
    return <BottomTabBar />;
  };

  const renderTitle = (): JSX.Element => {
    return (
      <div
        className="container propertiesDetails"
        style={{
          marginTop: "40px",
          padding: "5px 30px",
        }}
      >
        <h2
          style={{
            fontSize: "1.5rem",
            fontWeight: "700",
            color: "#2c3e50",
            marginBottom: "10px",
            textTransform: "capitalize",
          }}
        >
          {propertyData?.property_name || "Property Name"}
        </h2>

        {(propertyData?.locality_name || propertyData?.state) && (
          <p
            style={{
              fontSize: "1.1rem",
              color: "#555",
              margin: "4px 0",
            }}
          >
            {propertyData?.locality_name && propertyData.locality_name}
            {propertyData?.locality_name && propertyData?.state ? ", " : ""}
            {propertyData?.state && propertyData.state}
          </p>
        )}
      </div>
    );
  };

  const renderCards = (): JSX.Element => {
    // const [selectedTab, setSelectedTab] = React.useState("All");

    const genderOptions = [
      { label: "Male", value: "Male" },
      { label: "Female", value: "Female" },
      { label: "Others", value: "Others" },
    ];

    const roomSharingType: Record<string, string> = {
      "1": "Single Sharing",
      "2": "Double Sharing",
      "3": "Triple Sharing",
      "4": "Multi Sharing",
    };

    // console.log(">>>room type<<<", roomType);
    // console.log(">>>propertyRoomDetailLoading<<<", propertyRoomDetailLoading);
    // ✅ Filtered data based on selected tab
    const filteredRooms =
      selectedTab === "All"
        ? roomType
        : roomType?.filter(
            (room) => roomSharingType[room.room_type_id] === selectedTab,
          );

    return (
      <>
        <div>
          {/* 🔹 Tabs Section */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              gap: "8px",
              overflowX: "auto", // ✅ Enables horizontal scroll
              whiteSpace: "nowrap", // ✅ Keeps tabs in one line
              padding: "10px 0",
              margin: "0px 30px 20px 30px",
              scrollbarWidth: "none", // ✅ Hide scrollbar (Firefox)
            }}
            className="scrollable-tabs"
          >
            {[
              "All",
              "Single Sharing",
              "Double Sharing",
              "Triple Sharing",
              "Multi Sharing",
            ].map((tab) => (
              <button
                key={tab}
                onClick={() => setSelectedTab(tab)}
                style={{
                  padding: "6px 10px",
                  fontSize: "15px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                  backgroundColor:
                    selectedTab === tab ? "var(--primary-color)" : "#f4f4f4",
                  color: selectedTab === tab ? "#fff" : "#333",
                  fontWeight: 600,
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                }}
              >
                {tab}
              </button>
            ))}
          </div>

          {propertyRoomDetailLoading && (
            <div style={{ textAlign: "center", marginTop: "20px" }}>
              <CustomLoader />
            </div>
          )}

          {/* If no rooms found */}
          {!propertyRoomDetailLoading && filteredRooms?.length === 0 && (
            <div style={{ textAlign: "center", marginTop: "20px" }}>
              <p style={{ color: "#888", fontSize: "16px" }}>
                No rooms available for this category.
              </p>
            </div>
          )}

          {/* 🔹 Room Cards */}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "0px",
              justifyContent: "center",
            }}
          >
            {!propertyRoomDetailLoading &&
              filteredRooms?.map?.((room, index) => {
                const isRoomAvailable = (room.available_rooms ?? 0) > 0;
                const isSoldOut = !isRoomAvailable;

                return (
                  <div
                    className="room-card"
                    key={index}
                    style={{ position: "relative", margin: "10px" }}
                  >
                    {/* Sold Out Badge */}
                    {/* {isSoldOut && (
                <span
                  style={{
                    position: "absolute",
                    top: "19px",
                    right: "25px",
                    backgroundColor: "#ff4d4f",
                    color: "white",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    fontWeight: "600",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    whiteSpace: "nowrap",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                    zIndex: 10,
                  }}
                >
                  Sold Out
                </span>
              )} */}

                    {/* Room Info */}
                    <span style={{ fontWeight: "bold", fontSize: "15px" }}>
                      {roomSharingType[room.room_type_id]}
                    </span>

                    <div
                      className="room-card-header"
                      style={{ marginTop: "15px" }}
                    >
                      <h2 className="room-title">{room.room_type_name}</h2>
                    </div>

                    {/* <p className="room-price">₹{room.unit_rent} / bed</p> */}
                    <p className="room-price">
                      ₹ {formatIndianNumber(room.unit_rent)} / bed
                    </p>

                    <div className="room-details">
                      <p>
                        <img
                          src={roomAvailable}
                          alt="Room Available"
                          className="availability-icon"
                        />
                        <strong>Availability:</strong>{" "}
                        {room?.available_rooms
                          ? `Only ${room?.available_rooms} rooms left`
                          : "Rooms not available"}
                      </p>

                      <p>
                        <img
                          src={cash}
                          alt="Room Available"
                          className="availability-icon"
                        />
                        <strong>Security Deposit:</strong>{" "}
                        {room?.security_deposit_months?.toLowerCase() ?? "N/A"}
                      </p>

                      {/* Amenities */}
                      <div
                        className="room-details"
                        style={{ paddingTop: "5px" }}
                      >
                        <ul className="amenities-list">
                          {room?.features?.map((item, i) => (
                            <li key={i}>
                              <img src={item?.icon} alt="" />{" "}
                              {item?.feature_name}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>

                    {/* Buttons */}
                    <div style={{ display: "flex", gap: "10px" }}>
                      <button
                        className="book-now-button ctaBtn1"
                        onClick={() => {
                          if (!isRoomAvailable) return;
                          console.log(room, propertyData);
                          navigate("/room-booking", {
                            state: { room, propertyData },
                          });
                        }}
                        disabled={!isRoomAvailable}
                        style={{
                          flex: 1,
                          padding: "12px 0",
                          border: "none",
                          borderRadius: "8px",
                          backgroundColor: isRoomAvailable
                            ? "orange"
                            : "#ffa5008c",
                          cursor: isRoomAvailable ? "pointer" : "not-allowed",
                          color: "white",
                          fontWeight: 600,
                          boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                          transition: "background-color 0.3s ease",
                          fontSize: "14px",
                        }}
                      >
                        {/* Book Now */}
                        {isRoomAvailable ? "Book Now" : "Sold Out"}
                      </button>

                      <button
                        className="book-now-button ctaBtn2"
                        onClick={() => {
                          handleRequestCallback(room);

                          setIsShowContactModal(true);
                          setSelectedProperty(room);
                          //(room?.property_id);
                          // handleWebCallLead(room?.property_id);
                        }}
                        style={{
                          flex: 1,
                          padding: "12px 0",
                          border: "none",
                          borderRadius: "8px",
                          backgroundColor: "yellow",
                          color: "var(--primary-color)",
                          cursor: "pointer",
                          fontWeight: 600,
                          fontSize: "14px",
                          boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                        }}
                      >
                        {/* Call Owner */}
                        Schedule Visit
                      </button>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
        {isShowContactModal && (
          <ContactOwnerModal
            selectedProperty={selectedProperty}
            setIsOpen={setIsShowContactModal}
            isSubmitting={WebCallApiLoading}
            handleSubmit={(prefs) => handleWebCallLead(prefs)}
          />
        )}
      </>
    );
  };

  // const renderCards = (): JSX.Element => {

  //   // const genderOptions = [
  //   //   { label: "Male", value: "Male" },
  //   //   { label: "Female", value: "Female" },
  //   //   { label: "Others", value: "Others" },
  //   // ];

  //   const roomSharingType: Record<string, string> = {
  //     "1": "Single Sharing",
  //     "2": "Double Sharing",
  //     "3": "Triple Sharing",
  //     "4": "Multi Sharing",
  //   };

  //   return (
  //     <div >
  //       <div
  //         style={{
  //           display: "flex",
  //           flexWrap: "wrap",
  //           gap: "0px",
  //           justifyContent: "center",
  //         }}
  //       >
  //         {roomType?.map?.((room, index) => {
  //           // console.log(room, "room details here");

  //           const isRoomAvailable = (room.available_rooms ?? 0) > 0;
  //             const isSoldOut = !isRoomAvailable;

  //           return (
  //             <div className="room-card" key={index}  style={{ position: "relative" }} >
  //               {/* Sold Out badge absolutely positioned */}
  //     {isSoldOut && (
  //       <span
  //         style={{
  //           position: "absolute",
  //           top: "19px",
  //           right: "25px",
  //           backgroundColor: "#ff4d4f",
  //           color: "white",
  //           padding: "4px 8px",
  //           borderRadius: "4px",
  //           fontWeight: "600",
  //           fontSize: "12px",
  //           textTransform: "uppercase",
  //           whiteSpace: "nowrap",
  //           boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
  //           zIndex: 10,
  //         }}
  //       >
  //         Sold Out
  //       </span>
  //     )}

  //      <span style={{fontWeight:"bold", fontSize:"15px"}}>
  //         {roomSharingType[room.room_type_id]}
  //       </span>
  //             <div className="room-card-header" style={{marginTop:"15px"}}>

  //               <h2 className="room-title">
  //                 {room.room_type_name}
  //               </h2>
  //             </div>

  //             <p className="room-price">₹{room.unit_rent} / bed</p>

  //             <div className="room-details">
  //               <p>
  //                 <img
  //                   src={roomAvailable}
  //                   alt="Room Available"
  //                   className="availability-icon"
  //                 />
  //                 <strong> Availability:</strong>
  //                 {room?.available_rooms ? (
  //                   <>Only {room?.available_rooms ?? "-"} rooms left</>
  //                 ) : (
  //                   <>Rooms not available</>
  //                 )}
  //               </p>
  //               <p>
  //                 <img
  //                   src={cash}
  //                   alt="Room Available"
  //                   className="availability-icon"
  //                 />
  //                 <strong>Security Deposit:</strong>{" "}
  //                 {room?.security_deposit_months.toLowerCase() ?? "N/A"}
  //               </p>

  //               <div className="room-details" style={{ paddingTop: "5px" }}>
  //                 {/* <p>
  //                   <strong>Amenities:</strong>
  //                 </p> */}
  //                 <ul className="amenities-list">
  //                   {room?.features?.map((item, i) => (
  //                     <li key={i}>
  //                       <img src={item?.icon} alt="" />
  //                       {item?.feature_name}
  //                     </li>
  //                     // <li key={i}>{item?.feature_name}</li>
  //                   ))}
  //                 </ul>
  //               </div>
  //             </div>

  //             <div style={{ display: "flex", gap: "10px" }}>
  //               <button
  //                 className="book-now-button"
  //                 onClick={() => {
  //                   // setSelectedRoomType(room?.room_type_name);
  //                   // setIsModalOpen(true);
  //                    if (!isRoomAvailable) return;
  //                    navigate("/room-booking", { state: { room, propertyData } });
  //                 }}
  //                 disabled={!isRoomAvailable}
  //                 style={{
  //                   flex: 1,
  //                   padding: "12px 0",
  //                   border: "none",
  //                   borderRadius: "8px",
  //                   // backgroundColor: '#7065F0',
  //                   // backgroundColor: "var(--primary-color)",
  //                   backgroundColor: isRoomAvailable ? "var(--primary-color)" : "#014d4ead",
  //                   cursor: isRoomAvailable ? "pointer" : "not-allowed",
  //                   color: "white",
  //                   display: "flex",
  //                   alignItems: "center",
  //                   justifyContent: "center",
  //                   fontWeight: 600,
  //                   boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
  //                   transition: "background-color 0.3s ease",
  //                   fontSize: "14px",
  //                 }}
  //               >
  //                 Book Now
  //               </button>
  //               <button
  //                 className="book-now-button"
  //                 // style={{ fontSize: "12px" }}
  //                 // onClick={() => {
  //                 //     setSelectedRoomType(room?.room_type_name);
  //                 //     setIsModalOpen(true);
  //                 // }}
  //                 style={{
  //                   flex: 1,
  //                   padding: "12px 0",
  //                   border: "none",
  //                   borderRadius: "8px",
  //                   backgroundColor: "#ededed",
  //                   color: "var(--primary-color)",
  //                   cursor: "pointer",
  //                   display: "flex",
  //                   alignItems: "center",
  //                   justifyContent: "center",
  //                   fontWeight: 600,
  //                   boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
  //                   transition: "background-color 0.3s ease",
  //                   fontSize: "14px",
  //                 }}
  //                 // onClick={() => {
  //                 //     // if (room.showModal) {

  //                 //     // }
  //                 //     // setSelectedRoomType(room?.room_type_name);
  //                 //     setIsModalOpen2(true);
  //                 // }}
  //                 onClick={() => handleRequestCallback(room)}
  //               >
  //                 Request Call
  //               </button>
  //             </div>
  //           </div>
  //           )
  //         })}
  //       </div>

  //       {/* {isModalOpen && (
  //                   <div className="modal-overlay">
  //                       <div className="modal-content">
  //                           <h2>Book Your Room</h2>
  //                           <form>
  //                               <label>
  //                                   Select Room Type:
  //                                   <select
  //                                       required
  //                                       value={selectedRoomType}
  //                                       onChange={(e) => setSelectedRoomType(e.target.value)}
  //                                   >
  //                                       <option value="">-- Choose an option --</option>
  //                                       {roomType.map((room, index) => (
  //                                           <option key={index} value={room.room_type_name}>
  //                                               {room.room_type_name} Sharing
  //                                           </option>
  //                                       ))}
  //                                   </select>

  //                               </label>

  //                                        <div className="bill-summary">
  //                                   <div className="bill-row">
  //                                       <span>Payment Amount:</span>
  //                                       <span>Rs. 10,000</span>
  //                                   </div>
  //                                   <div className="bill-row">
  //                                       <span>GST (18%):</span>
  //                                       <span>Rs. 1,800</span>
  //                                   </div>
  //                                   <div className="bill-row total">
  //                                       <span>Total Payable:</span>
  //                                       <span>Rs. 11,800</span>
  //                                   </div>
  //                               </div>

  //                               <div className="modal-buttons">
  //                                   <button
  //                                       type="button"
  //                                       className="cancel-button"
  //                                       onClick={() => setIsModalOpen(false)}
  //                                   >
  //                                       Cancel
  //                                   </button>
  //                                   <div
  //                                       className="pay-button"
  //                                       onClick={() => navigate('/booking-success')}
  //                                   >
  //                                       Confirm
  //                                   </div>
  //                               </div>
  //                           </form>
  //                       </div>
  //                   </div>
  //               )} */}

  //       {confirmModal && (
  //         <div className="modal-overlay">
  //           <div className="modal-content">
  //             <div
  //               style={{
  //                 display: "flex",
  //                 flexDirection: "column",
  //                 alignItems: "center",
  //               }}
  //             >
  //               <img
  //                 alt="Success"
  //                 // src='https://george-fx.github.io/nuton_api/assets/images/08.png'
  //                 // src={require("../assets/other/check.png")}
  //                 src={require("../assets/other/checked.png")}
  //                 // src="#"
  //                 style={{ width: "30%", height: "auto", margin: "30px 0" }}
  //               />
  //               {/* <h2 style={{ textAlign: 'center', marginBottom: 10 }}>
  //                                   Request Sent Successfully
  //                               </h2> */}
  //               <p
  //                 style={{
  //                   textAlign: "center",
  //                   marginBottom: 10,
  //                   lineHeight: "1.6",
  //                   fontSize: "18px",
  //                   fontWeight: "bold",
  //                 }}
  //               >
  //                 Your Booking Created Successfully!
  //               </p>
  //               <text.T14
  //                 style={{
  //                   whiteSpace: "pre-line",
  //                   textAlign: "center",
  //                 }}
  //               >
  //                 Our team will contact you soon.
  //               </text.T14>
  //               <p
  //                 style={{
  //                   whiteSpace: "pre-line",
  //                   textAlign: "center",
  //                   margin: "10px 0",
  //                   color: "blue",
  //                   fontSize: "14px",
  //                   textDecoration: "underline",
  //                 }}
  //                 onClick={() => navigate("/my-booking")}
  //               >
  //                 View Booking
  //               </p>
  //               <div
  //                 onClick={() => {
  //                   setConfirmModal(false);
  //                 }}
  //                 style={{
  //                   width: "100%",
  //                   color: theme.colors.white,
  //                   height: 40,
  //                   textAlign: "center",
  //                   fontSize: 14,
  //                   borderRadius: 10,
  //                   userSelect: "none",
  //                   cursor: "pointer",
  //                   textTransform: "capitalize",
  //                   // background: "#000000d1",
  //                   background: "var(--primary-color)",
  //                   fontFamily: "Lato-Bold",
  //                   marginTop: 12, // optional spacing
  //                   display: "flex",
  //                   alignItems: "center",
  //                   justifyContent: "center",
  //                 }}
  //               >
  //                 Continue
  //               </div>
  //             </div>
  //             {/* <div className="modal-buttons">
  //                               <button
  //                                   type="button"
  //                                   className="cancel-button"
  //                                   onClick={() => setIsModalOpen2(false)}
  //                               >
  //                                   Thank You
  //                               </button>
  //                           </div> */}
  //           </div>
  //         </div>
  //       )}

  //       {/* {isModalOpen && (
  //         <div className="modal-overlay">
  //           <div className="modal-content">
  //             <h2>Book Now</h2>
  //             <form
  //               onSubmit={(e) => {
  //                 e.preventDefault();
  //                 handleSubmitTenant();
  //               }}
  //             >
  //               <label className="form-label">
  //                 <span style={{ fontWeight: "bold" }}>Full Name:</span>

  //                 <input
  //                   type="text"
  //                   name="fullName"
  //                   placeholder="Name"
  //                   value={formData.fullName}
  //                   onChange={handleChange}
  //                 />
  //               </label>

  //                  <div className="form-group" style={{ marginBottom: "0px" }}>
  //                 <label
  //                   className="form-label"
  //                   style={{
  //                     display: "block",
  //                     marginBottom: "0.5rem",
  //                     fontWeight: "bold",
  //                     fontSize: "14px",
  //                   }}
  //                 >
  //                   Gender
  //                 </label>

  //                 <div
  //                   className="radio-group"
  //                   style={{
  //                     display: "flex",
  //                     gap: "24px",
  //                     alignItems: "center",
  //                     padding: "4px 0",
  //                   }}
  //                 >
  //                   {genderOptions.map(({ label, value }) => (
  //                     <label
  //                       key={value}
  //                       style={{
  //                         display: "flex",
  //                         alignItems: "center",
  //                         gap: "8px",
  //                         fontSize: "14px",
  //                         lineHeight: "1.5",
  //                         cursor: "pointer",
  //                       }}
  //                     >
  //                       <input
  //                         type="radio"
  //                         name="gender"
  //                         value={value}
  //                         checked={formData.gender === value}
  //                         onChange={(e) =>
  //                           setFormData((prev) => ({
  //                             ...prev,
  //                             gender: e.target.value,
  //                           }))
  //                         }
  //                         style={{ margin: "0", accentColor: "#014d4e" }}
  //                       />
  //                       {label}
  //                     </label>
  //                   ))}
  //                    <p style={{ color: "white" }}>Selected: {formData.gender}</p>
  //                 </div>
  //               </div>
  //               <div className="form-group" style={{ marginBottom: "1rem" }}>
  //                 <label
  //                   htmlFor="contactNumber"
  //                   className="form-label"
  //                   style={{
  //                     display: "block",
  //                     marginBottom: "0.5rem",
  //                     fontWeight: "bold",
  //                   }}
  //                 >
  //                   Contact Number:
  //                 </label>
  //                 <div
  //                   style={{
  //                     display: "flex",
  //                     gap: "8px",
  //                     alignItems: "center",
  //                   }}
  //                 >
  //                   <input
  //                     type="tel"
  //                     name="contact_number"
  //                     placeholder="Phone number"
  //                     value={formData.contact_number}
  //                     onChange={(e) => {
  //                       const value = e.target.value;
  //                       // Allow only digits and up to 10 characters
  //                       if (/^\d{0,10}$/.test(value)) {
  //                         setFormData({ ...formData, contact_number: value });
  //                       }
  //                     }}
  //                     maxLength={10}
  //                     style={{
  //                       padding: "0.5rem",
  //                       border: "1px solid #ccc",
  //                       borderRadius: "4px",
  //                     }}
  //                     // readOnly
  //                     disabled
  //                   />
  //                 </div>
  //               </div>

  //               <label>
  //                 <span className="form-label" style={{ fontWeight: "bold" }}>
  //                   Email:
  //                 </span>
  //                 <input
  //                   type="text"
  //                   placeholder="Email"
  //                   name="email"
  //                   value={formData.email}
  //                   onChange={handleChange}
  //                 />
  //               </label>
  //               <label
  //                 className="form-label"
  //                 style={{
  //                   display: "block",
  //                   marginBottom: "1rem",
  //                   fontWeight: "bold",
  //                 }}
  //               >
  //                 Occupation:
  //                 <select
  //                   name="occupation"
  //                   value={formData.occupation}
  //                   onChange={handleChange}
  //                   style={{
  //                     display: "block",
  //                     marginTop: "0.5rem",
  //                     padding: "0.5rem",
  //                     width: "100%",
  //                     border: "1px solid #ccc",
  //                     borderRadius: "4px",
  //                   }}
  //                   // required
  //                 >
  //                   <option value="">Select Occupation</option>
  //                   <option value="Student">Student</option>
  //                   <option value="Working">Working</option>
  //                 </select>
  //               </label>

  //               <div className="form-group">
  //                 <label
  //                   className="form-label"
  //                   style={{ fontWeight: "bold", fontSize: "14px" }}
  //                 >
  //                   Are you a B2B user?
  //                 </label>
  //                 <div
  //                   className="radio-group"
  //                   style={{
  //                     display: "flex",
  //                     gap: "24px",
  //                     alignItems: "center",
  //                   }}
  //                 >
  //                   {["Yes", "No"].map((value) => (
  //                     <label
  //                       key={value}
  //                       style={{
  //                         display: "flex",
  //                         alignItems: "center",
  //                         gap: "8px",
  //                         fontSize: "14px",
  //                         cursor: "pointer",
  //                       }}
  //                     >
  //                       <input
  //                         type="radio"
  //                         name="is_b2b_user"
  //                         value={value}
  //                         checked={formData.is_b2b_user === value}
  //                         onChange={handleChange}
  //                         style={{ margin: "0", accentColor: "#014d4e" }}
  //                       />
  //                       {value}
  //                     </label>
  //                   ))}
  //                 </div>
  //               </div>

  //               <div className="modal-buttons">
  //                 <button
  //                   type="button"
  //                   className="cancel-button"
  //                   onClick={() => setIsModalOpen(false)}
  //                 >
  //                   Cancel
  //                 </button>
  //                 <button
  //                   type="submit"
  //                   className="pay-button"
  //                   // onClick={handleSubmitTenant}
  //                   disabled={submitLoading}
  //                 >
  //                   {submitLoading ? "Submitting..." : "Submit"}
  //                 </button>
  //               </div>
  //             </form>
  //           </div>
  //         </div>
  //       )} */}

  //       {/* {isModalOpenDate && (
  //         <div className="modal-overlay">
  //           <div className="modal-content">
  //             <h2>Select Moving Date </h2>
  //             <form
  //               onSubmit={(e) => {
  //                 e.preventDefault();
  //                 handleAgreementSubmit(agreementDate);
  //                 callLeadServiceAPI();
  //               }}
  //             >
  //               <input
  //                 type="date"
  //                 placeholder="Select date"
  //                 value={agreementDate}
  //                 onChange={(e) => setAgreementDate(e.target.value)}
  //                 min={getTomorrowDate()}
  //                 onClick={(e: any) => e.currentTarget.showPicker?.()}
  //                 required
  //               />

  //               <div
  //                 className="modal-buttons"
  //                 style={{
  //                   display: "flex",
  //                   justifyContent: "flex-end",
  //                   gap: "10px",
  //                   marginTop: "1rem",
  //                 }}
  //               >
  //                 <button
  //                   type="button"
  //                   className="cancel-button"
  //                   onClick={() => setIsModalOpenDate(false)} // 👈 closes the date modal
  //                   style={{
  //                     padding: "0.5rem 1rem",
  //                     backgroundColor: "#e0e0e0",
  //                     border: "1px solid #ccc",
  //                     borderRadius: "4px",
  //                     cursor: "pointer",
  //                   }}
  //                 >
  //                   Cancel
  //                 </button>

  //                 <button
  //                   type="submit" // 👈 allows it to submit the form
  //                   className="pay-button"
  //                   disabled={AgreementAllotedLoading}
  //                   style={{
  //                     padding: "0.5rem 1rem",
  //                     // backgroundColor: "#4CAF50",
  //                     backgroundColor: "var(--primary-color)",
  //                     color: "white",
  //                     border: "none",
  //                     borderRadius: "4px",
  //                     cursor: "pointer",
  //                   }}
  //                 >
  //                   {AgreementAllotedLoading ? "Submitting..." : "Submit"}
  //                 </button>
  //               </div>
  //             </form>
  //           </div>
  //         </div>
  //       )} */}

  //       {/* {isModalOpen2 && (
  //                   <div className="modal-overlay">
  //                       <div className="modal-content">
  //                           <h2>Requst A Call Back</h2>
  //                           <form>
  //                               <label>
  //                                   Name:
  //                                   <input type="text" placeholder="name" />
  //                               </label>
  //                               <label>
  //                                   Phon No:
  //                                   <input type="text" placeholder="phon no" />
  //                               </label>

  //                               <label style={{ display: "block", marginBottom: "1rem" }}>
  //                                   Description:
  //                                   <textarea
  //                                       name="description"
  //                                       placeholder="Write your message or query here"
  //                                       rows={6}
  //                                       // rows="4"
  //                                       required
  //                                       style={{
  //                                           width: "100%",
  //                                           padding: "0.5rem",
  //                                           marginTop: "0.3rem",
  //                                           border: "1px solid #ccc",
  //                                           borderRadius: "4px",
  //                                           resize: "vertical",
  //                                           fontSize: "14px",
  //                                       }}
  //                                   ></textarea>
  //                               </label>

  //                               <div className="modal-buttons">
  //                                   <button
  //                                       type="button"
  //                                       className="cancel-button"
  //                                       onClick={() => setIsModalOpen2(false)}
  //                                   >
  //                                       Cancel
  //                                   </button>
  //                                   <div
  //                                       className="pay-button"

  //                                   >
  //                                       Submit
  //                                   </div>
  //                               </div>
  //                           </form>
  //                       </div>
  //                   </div>
  //               )} */}

  //       {isModalOpen2 && (
  //         <div className="modal-overlay">
  //           <div className="modal-content">
  //             <h2></h2>
  //             <p></p>
  //             <div
  //               style={{
  //                 display: "flex",
  //                 flexDirection: "column",
  //                 alignItems: "center",
  //               }}
  //             >
  //               <img
  //                 alt="Success"
  //                 src={require("../assets/nestfin/Nestfin_logo.png")}
  //                 style={{ width: "50%", height: "auto", marginBottom: 10 }}
  //               />
  //                 <img
  //                 alt="Success"
  //                 // src='https://george-fx.github.io/nuton_api/assets/images/08.png'
  //                 src={require("../assets/other/checked.png")}
  //                 style={{ width: "30%", height: "auto", margin: "30px 0" }}
  //               />
  //               <h2 style={{ textAlign: "center", marginBottom: 10 }}>
  //               Request Sent Successfully
  //               </h2>
  //               <text.T16
  //                 style={{
  //                   whiteSpace: "pre-line",
  //                   textAlign: "center",
  //                   marginBottom: 24,
  //                 }}
  //               >
  //                 Thank you! Our team will get in touch with you shortly.
  //               </text.T16>

  //               <div
  //                 onClick={() => {
  //                   setIsModalOpen2(false);
  //                 }}
  //                 style={{
  //                   width: "100%",
  //                   color: theme.colors.white,
  //                   height: 40,
  //                   textAlign: "center",
  //                   fontSize: 14,
  //                   borderRadius: 10,
  //                   userSelect: "none",
  //                   cursor: "pointer",
  //                   textTransform: "capitalize",
  //                   background: "#000000d1",
  //                   fontFamily: "Lato-Bold",
  //                   marginTop: 12, // optional spacing
  //                   display: "flex",
  //                   alignItems: "center",
  //                   justifyContent: "center",
  //                 }}
  //               >
  //                 Continue
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       )}

  //       {/* {isModalOpen3 && (
  //         <div className="modal-overlay">
  //           <div className="modal-content">
  //             <div
  //               style={{
  //                 display: "flex",
  //                 flexDirection: "column",
  //                 alignItems: "center",
  //               }}
  //             >
  //               <img
  //                 alt="Success"
  //                 src={require("../assets/nestfin/Nestfin_logo.png")}
  //                 style={{ width: "50%", height: "auto", marginBottom: 10 }}
  //               />
  //                <img
  //                 alt="Success"
  //                 // src='https://george-fx.github.io/nuton_api/assets/images/08.png'
  //                 src={require("../assets/other/warning2.png")}
  //                 style={{ width: "25%", height: "auto", margin: "30px 0" }}
  //               />
  //               <h2 style={{ textAlign: "center", marginBottom: 10 }}>
  //                 Something Went Wrong
  //               </h2>
  //               <p
  //                 style={{
  //                   textAlign: "center",
  //                   marginBottom: 10,
  //                   lineHeight: "1.6",
  //                 }}
  //               >
  //                 We couldn't process your request.
  //               </p>
  //               <text.T14
  //                 style={{
  //                   whiteSpace: "pre-line",
  //                   textAlign: "center",
  //                   marginBottom: 24,
  //                 }}
  //               >
  //                 Please try again later. If the issue persists, contact our
  //                 support team.
  //               </text.T14>
  //               <div
  //                 onClick={() => {
  //                   setIsModalOpen3(false);
  //                 }}
  //                 style={{
  //                   width: "100%",
  //                   color: theme.colors.white,
  //                   height: 40,
  //                   textAlign: "center",
  //                   fontSize: 14,
  //                   borderRadius: 10,
  //                   userSelect: "none",
  //                   cursor: "pointer",
  //                   textTransform: "capitalize",
  //                   // background: "#000000d1",
  //                   background: "#000000d1",
  //                   fontFamily: "Lato-Bold",
  //                   marginTop: 12, // optional spacing
  //                   display: "flex",
  //                   alignItems: "center",
  //                   justifyContent: "center",
  //                 }}
  //               >
  //                 Continue
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       )} */}
  //     </div>
  //   );
  // };

  const renderContent = (): JSX.Element => {
    return (
      <main>
        {renderTitle()}
        {renderCards()}
        {/* {renderSearchBar2()}
                {offerBanner()}
                {serachResult()} */}
      </main>
    );
  };

  return (
    <>
      {renderHeader()}
      {renderContent()}
      {renderBottomTabBar()}

      {isModalOpen2 && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2></h2>
            <p></p>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img
                alt="Success"
                src={require("../assets/nestfin/Nestfin_logo.png")}
                style={{ width: "50%", height: "auto", marginBottom: 10 }}
              />
              <img
                alt="Success"
                // src='https://george-fx.github.io/nuton_api/assets/images/08.png'
                src={require("../assets/other/checked.png")}
                style={{ width: "30%", height: "auto", margin: "30px 0" }}
              />
              <h2 style={{ textAlign: "center", marginBottom: 10 }}>
                {/* Request Sent Successfully */}
                Owner is Notified
              </h2>
              <text.T16
                style={{
                  whiteSpace: "pre-line",
                  textAlign: "center",
                  marginBottom: 24,
                }}
              >
                {/* Thank you! Our team will get in touch with you shortly. */}
                The owner will call you back shortly.
              </text.T16>
              <div
                onClick={() => {
                  setIsModalOpen2(false);
                }}
                style={{
                  width: "100%",
                  color: theme.colors.white,
                  height: 40,
                  textAlign: "center",
                  fontSize: 14,
                  borderRadius: 10,
                  userSelect: "none",
                  cursor: "pointer",
                  textTransform: "capitalize",
                  background: "#000000d1",
                  fontFamily: "Lato-Bold",
                  marginTop: 12, // optional spacing
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                Continue
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// ######################################################--------------------------------------------
// import axios from "axios";
// import { Swiper, SwiperSlide } from "swiper/react";
// import React, { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import useEmblaCarousel from "embla-carousel-react";
// import { components } from "../components";
// // import logo from "../../assets/nestfin/NexfinPng.png"
// import logo from "../assets/nestfin/Nestfin_logo.png";
// import { BottomTabBar } from "../navigation/BottomTabBar";
// import { text } from "../text";
// import { hooks } from "../hooks";
// import roomAvailable from "../assets/nestfin/deadline.png";
// import cash from "../assets/nestfin/cash.png";
// import { PropertyRoomType, Feature } from "../../src/types/types";

// import {
//   getRoomOptionsById,
//   propertyTanantAdd,
//   propertyTanantAgreementDetails,
//   propertyTanantBooking,
//   updateLeadProfile,
//   viewLeadProfile,
// } from "../environment";
// import useApi from "../customHook/useApi";

// import { toast } from "react-toastify";
// import { callService } from "../customHook/callService";
// import { theme } from "../constants";

// export interface APIResponse {
//   success: boolean;
//   statusCode: number;
//   data: PropertyRoomType[];
//   message: string;
// }

// export interface profileResponse {
//   success: boolean;
//   statusCode: number;
//   message: string;
//   tenant_id?: string;
// }

// // view profile data

// type Profile = {
//   full_name: string | null;
//   email: string | null;
//   phone_number: string | null;
//   gender: string | null;
//   dob: string | null;
//   pref_budget_min_range: number | null;
//   pref_budget_max_range: number | null;
//   pref_city_name: string | null;
//   pref_city_id: number | null;
//   pref_locality_id: number | null;
// };

// export interface profileResponse {
//   success: boolean;
//   statusCode: number;
//   data: Profile;
//   // message?: string;
// }

// export const RoomDetails: React.FC = () => {
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isModalOpen2, setIsModalOpen2] = useState(false);
//   const [isModalOpen3, setIsModalOpen3] = useState(false);
//     const [confirmModal, setConfirmModal] = useState(false)

//   const location = useLocation();
//   const navigate = hooks.useNavigate();
//   const [selectedRoomType, setSelectedRoomType] = useState("");
//   const [roomType, setRoomType] = useState<PropertyRoomType[]>([]);

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);

//   // API CALL for room details
//   const {
//     data: propertyRoomDetailData,
//     loading: propertyRoomDetailLoading,
//     callApi: fetchPropertyRoomDetail,
//   } = useApi<APIResponse>(getRoomOptionsById, {
//     method: "POST",
//     autoCall: false,
//     dependencies: [],
//   });

//   useEffect(() => {
//     const leadId = localStorage.getItem("lead_profile_id");
//     // console.log(location.state, "location vikas kumar");
//     const propertyId = localStorage.getItem("property_id");
//     // const propertyId = location.state.property_id
//     fetchPropertyRoomDetail({
//       leadId: leadId,
//       propertyId: propertyId,
//       // leadId: "LEAD-B-2025-05-001",
//       // propertyId: "PR-G-2025-05-072",
//     });
//   }, [location.state]);

//   useEffect(() => {
//     if (propertyRoomDetailData?.data) {
//       console.log(
//         "✅ propertyRoomDetailData received:",
//         propertyRoomDetailData?.data
//       );
//       setRoomType(propertyRoomDetailData?.data);
//     }
//   }, [propertyRoomDetailData]);

//   // handle pop form
//   interface UserFormData {
//     fullName: string;
//     gender: string;
//     country_code: string;
//     contact_number: string;
//     is_b2b_user: string;
//     occupation: string;
//     email: string;
//     // property_id: string;
//   }

//   const [formData, setFormData] = useState<UserFormData>({
//     fullName: "",
//     gender: "",
//     country_code: "91",
//     contact_number: "",
//     is_b2b_user: "No",
//     occupation: "",
//     email: "",
//     // property_id: "",
//   });

//   const handleChange = (e: any) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const [errors, setErrors] = useState<{ [key: string]: string }>({});

//   const validateForm = (): string | null => {
//     if (!formData.fullName?.trim()) {
//       return "Full Name is required";
//     } else if (formData.fullName.trim().length < 3) {
//       return "Full Name must be at least 3 characters";
//     } else if (formData.fullName.trim().length > 15) {
//       return "Full Name must not exceed 15 characters";
//     }

//     if (!formData.gender) {
//       return "Please select your gender";
//     }

//     if (!formData.contact_number?.trim()) {
//       return "Contact Number is required";
//     } else if (!/^\d{10}$/.test(formData.contact_number)) {
//       return "Contact Number must be exactly 10 digits";
//     }

//     if (!formData.email?.trim()) {
//       return "Email is required";
//     } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
//       return "Enter a valid email";
//     }

//     if (!formData.occupation) {
//       return "Occupation is required";
//     }

//     if (!formData.is_b2b_user) {
//       return "Please select B2B user type";
//     }

//     return null; // ✅ All fields are valid
//   };

//   // API CALL FOR /view-lead-profile
//   const {
//     data: profileData,
//     loading: profileLoading,
//     callApi: fetchProfile,
//   } = useApi<profileResponse>(viewLeadProfile, {
//     method: "POST",
//     autoCall: false,
//     dependencies: [],
//   });

//   // 1. API Call Trigger (on mount)
//   useEffect(() => {
//     const leadId = localStorage.getItem("lead_profile_id");
//     if (leadId) {
//       fetchProfile({ leadId });
//     }
//   }, []);

//   useEffect(() => {
//     if (profileData?.data) {
//       const data = profileData.data;

//       setFormData((prev) => ({
//         ...prev,
//         fullName: data.full_name ?? "",
//         gender: data.gender ?? "",
//         contact_number: data.phone_number ?? "",
//         email: data.email ?? "",
//       }));
//     }
//   }, [profileData]);

//   // API CALL FOR UPDATE DATA
//   const {
//     data: UpdateProfileData,
//     loading: UpdateProfileLoading,
//     callApi: updatePayload,
//   } = useApi<profileResponse>(updateLeadProfile, {
//     method: "POST",
//     autoCall: false,
//     dependencies: [],
//   });

//   useEffect(() => {
//     if (UpdateProfileData?.success) {
//       console.log("Profile updated successfully");
//     }
//   }, [UpdateProfileData]);

//   // useEffect(() => {
//   //     const leadId = localStorage.getItem("lead_profile_id");

//   //     const updatedPayload = {
//   //         leadId: leadId,
//   //         full_name: profileData?.data?.full_name,
//   //         email: profileData?.data?.email,
//   //         phone_number: profileData?.data?.phone_number,
//   //         gender: genderAPI,
//   //         dob: profileData?.data?.dob,
//   //         pref_budget_min_range: String(minAmountStr),
//   //         pref_budget_max_range: String(maxAmountStr),
//   //         pref_city_id: cityId,
//   //         pref_locality_id: id[0],
//   //     };

//   //     console.log("Merged update payload:", updatedPayload);
//   //     updatePayload(updatedPayload);
//   // }, []);

//   // api calling for submit data

//   // API CALL
//   const {
//     data: submitResponse,
//     loading: submitLoading,
//     callApi: submitTenant,
//   } = useApi<any>(propertyTanantAdd, {
//     method: "POST",
//     autoCall: false,
//     dependencies: [],
//   });

//   //2nd api call

//   const {
//     data: PropertyAllotedResponse,
//     loading: PropertyAllotedLoading,
//     callApi: propertyBooking,
//   } = useApi<any>(propertyTanantBooking, {
//     method: "POST",
//     autoCall: false,
//     dependencies: [],
//   });

//   // 3rd api

//   const [isModalOpenDate, setIsModalOpenDate] = useState(false);
//   const [agreementDate, setAgreementDate] = useState("");
//   const [isRequestSent, setIsRequestSent] = useState(false);

//   const {
//     data: AgreementAllotedResponse,
//     loading: AgreementAllotedLoading,
//     callApi: allotAgreement,
//   } = useApi<any>(propertyTanantAgreementDetails, {
//     method: "POST",
//     autoCall: false,
//     dependencies: [],
//   });

//   const handleUpdateProfile = () => {
//     const leadId = localStorage.getItem("lead_profile_id");

//     const updatedPayload = {
//       leadId: leadId,
//       full_name: formData.fullName, // override with form input
//       email: formData.email,
//       phone_number: formData.contact_number,
//       gender: formData.gender,
//       dob: profileData?.data?.dob,
//       pref_budget_min_range: profileData?.data?.pref_budget_min_range,
//       pref_budget_max_range: profileData?.data?.pref_budget_max_range,
//       pref_city_id: profileData?.data?.pref_city_id,
//       pref_locality_id: profileData?.data?.pref_locality_id, // from locality selection
//     };

//     // console.log("Final update profile payload:", updatedPayload);
//     updatePayload(updatedPayload);
//   };

//   const handleSubmitTenant = async () => {
//     const errorMessage = validateForm();
//     if (errorMessage) {
//       toast.error(errorMessage);
//       return;
//     }

//     try {
//       const propertyId = localStorage.getItem("property_id");
//       const payload = { ...formData, property_id: propertyId };

//       const tenantResponse = await submitTenant(payload); // callApi from useApi
//       console.log("API Response:", tenantResponse);

//       if (tenantResponse?.success) {
//         const tenant_id = tenantResponse.tenant_id;
//         localStorage.setItem("tenant_id", tenant_id);
//         // toast.success(tenantResponse.message);

//         // ✅ Get property_id from localStorage
//         // const property_id = localStorage.getItem("property_id");

//         const property_id = localStorage.getItem("property_id");

//         if (!property_id) {
//           toast.error("Property ID is required");
//           return;
//         }

//         // Call 2nd Api
//         const bookingPayload = {
//           tenant_id,
//           property_id,
//         };

//         const bookingResponse = await propertyBooking(bookingPayload);
//         // console.log(bookingResponse);
//         if (bookingResponse?.success) {
//           localStorage.setItem("booking_id", bookingResponse?.bookingId);
//           //   localStorage.setItem("tenant_id", bookingResponse?.tenant_id);
//           // toast.success(bookingResponse?.message);

//           // toast.success(bookingResponse?.message || "Property allotted successfully");

//           // ✅ Update profile here
//           handleUpdateProfile(); // 👈 call the merged update API

//           // ✅ Now open date modal to allow agreement step (step 3)
//           setIsModalOpen(false);
//           setIsModalOpenDate(true);
//         } else {
//           toast.error("Property allotment failed");
//         }
//         // ✅ Clear the form data
//         setFormData({
//           fullName: "",
//           gender: "",
//           country_code: "91",
//           contact_number: "",
//           is_b2b_user: "",
//           occupation: "",
//           email: "",
//           //   property_id: "",
//         });

//         // after these proecess then show pop with date picker  so user pick the date and then call 3rd api
//       } else {
//         toast.error("Tenant creation failed");
//       }
//     } catch (error) {
//       console.error("API Error:", error);
//       toast.error("Something went wrong");
//     }
//   };

//   // handleAgreementSubmit
//   const handleAgreementSubmit = async (agreementDate: string) => {
//     const tenant_id = localStorage.getItem("tenant_id");
//     const property_id = localStorage.getItem("property_id");
//     const bookingId = localStorage.getItem("booking_id");

//     if (!tenant_id || !property_id || !bookingId || !agreementDate) {
//       toast.error("Missing data for agreement allocation");
//       return;
//     }

//     const unit_rent = roomType[0].unit_rent;

//     // Extract the number part from "2 Months"
//     const months = parseInt(roomType[0].security_deposit_months); // This will give you 2
//     // console.log(months, "security");

//     // Calculate security deposit
//     const se_deposit = unit_rent * months;
//     // console.log(months, "security");
//     // console.log(se_deposit, "security");

//     const noticeperiod_duration = `${
//       parseInt(roomType[0].noticeperiod_months) * 30
//     } Days`;

//     const payload = {
//       tenant_id,
//       property_id,
//       booking_id: bookingId,
//       movein_date: agreementDate,
//       //   renttype_enum_id: "RENTAL_TYPE_1M",
//       //   rent_amount: roomType[0].unit_rent,
//       //   mentinance_amount: "500",
//       //   security_deposit_amt: se_deposit,
//       //   agreement_start_date: agreementDate,
//       //   tanant_move_in_date: agreementDate,
//       //   rent_cycle_enum_id: "PMS_RENTAL_CYCLE_DATE_1",
//       //   agreement_duration_month: roomType[0].agreement_duration_months,
//       //   lockin_duration_month: roomType[0].lockinperiod_months,
//       //   noticeperiod_duration_month: "10 Days",
//       // noticeperiod_duration_month: noticeperiod_duration,
//     };
//     try {
//       const res = await allotAgreement(payload);
//       if (res?.success) {
//         setConfirmModal(true)
//         // toast.success("Vikas kumar");
//         setIsModalOpenDate(false); // Close date modal
//         setAgreementDate("");
//       } else {
//         toast.error("Failed to allocate agreement");
//       }
//     } catch (err) {
//       console.error(err);
//       toast.error("Agreement API failed");
//     }
//   };

//   const callLeadServiceAPI = async () => {
//     try {
//       const leadId = localStorage.getItem("lead_profile_id") || "";
//       if (!leadId) return;

//       const response = await callService("PAID_BOOKING");
//     } catch (error) {
//       console.error("Error while calling PAID_BOOKING API", error);
//     }
//   };

//   //         const payload = {
//   //     tenant_id,
//   //     property_id,
//   //     bookingId,
//   //     renttype_enum_id: "RENTAL_TYPE_1M",
//   //     rent_amount: "15000",
//   //     mentinance_amount: "500",
//   //     security_deposit_amt: "15000",
//   //     agreement_start_date: agreementDate,
//   //     tanant_move_in_date: agreementDate,
//   //     rent_cycle_enum_id: "PMS_RENTAL_CYCLE_DATE_1",
//   //     agreement_duration_month: "2 Months",
//   //     lockin_duration_month: "6 Months",
//   //     noticeperiod_duration_month: "10 Days",
//   // };

//   const getTomorrowDate = () => {
//     const today = new Date();
//     today.setDate(today.getDate()); // move to next day
//     return today.toISOString().split("T")[0]; // format as YYYY-MM-DD
//   };

//   const handleRequestCallback = async (room: any) => {
//     try {
//       const payload = [
//         { param: "PROPERTY_ID", value: room?.property_id },
//         { param: "ROOM_TYPE_ID", value: room?.room_type_id },
//         { param: "PROPERTY_NAME", value: room?.property_name },
//         { param: "ROOM", value: room?.room_type_name },
//       ];

//       // const response = await callService("REQUEST_CALLBACK");
//       const response = await callService("SENT_INQUIRY", payload);
//       // console.log("✅ SENT_INQUIRY success:", response);

//       console.log("room data", room);
//       // const payload = [
//       //   { param: "NAME", value: formData?.full_name },
//       //   { param: "EMAIL", value: formData?.email },
//       //   { param: "MESSAGE", value: formData?.message },
//       // ];

//       // Open modal or show confirmation
//       setIsModalOpen2(true);
//     } catch (error) {
//       setIsModalOpen3(true);
//       console.error("❌ SENT_INQUIRY failed:", error);
//     }
//   };

//   // Start Component
//   const renderHeader = (): JSX.Element => {
//     return (
//       <components.Header
//         goBack={false}
//         line={false}
//         leftlogo={true}
//            rightlogo={false}
//         // search={true}
//         filter={false}
//         // logo={true}
//         title={""}
//         centerImageSrc={logo}
//       />
//     );
//   };

//   const renderBottomTabBar = (): JSX.Element => {
//     return <BottomTabBar />;
//   };

//   const renderTitle = (): JSX.Element => {
//     return (
//       <div
//         className="container propertiesDetails"
//         style={{ marginTop: "20px" }}
//       >
//         <text.H4
//           style={{ marginBottom: 6, textAlign: "center" }}
//           numberOfLines={2}
//         >
//           {/* {
//               roomType.map((item, index) => (
//                   <h1>{item.contact_phone}</h1>
//               ))
//           } */}
//           {roomType[0] && <h1>{roomType[0].property_name}</h1>}

//           {/* Discover Affordable Living at StayNest */}
//         </text.H4>
//       </div>
//     );
//   };

//   const renderCards = (): JSX.Element => {
//     const genderOptions = [
//       { label: "Male", value: "Male" },
//       { label: "Female", value: "Female" },
//       { label: "Other", value: "Other" },
//     ];
//     return (
//       <div style={{ display: "flex", justifyContent: "center" }}>
//         <div
//           style={{
//             display: "flex",
//             flexWrap: "wrap",
//             gap: "0px",
//             justifyContent: "center",
//           }}
//         >
//           {roomType?.map?.((room, index) => (
//             <div className="room-card" key={index}>
//               <div className="room-card-header">
//                 <h2 className="room-title">
//                   {room.room_type_name}
//                   <div>
//                     <ul>
//                       {room.features.slice(0, 1).map((item, i) => (
//                         <li key={i}>({item.feature_name})</li>
//                       ))}
//                     </ul>
//                   </div>
//                 </h2>
//               </div>
//               <p className="room-price">₹{room.unit_rent}/bed</p>

//               <div className="room-details">
//                 <p>
//                   <img
//                     src={roomAvailable}
//                     alt="Room Available"
//                     className="availability-icon"
//                   />
//                   <strong> Availability:</strong>
//                   {room?.available_rooms ? (
//                     <>Only {room?.available_rooms ?? "-"} Rooms Left</>
//                   ) : (
//                     <>No Rooms Available</>
//                   )}
//                 </p>
//                 <p>
//                   <img
//                     src={cash}
//                     alt="Room Available"
//                     className="availability-icon"
//                   />
//                   <strong>Security Deposit:</strong>{" "}
//                   {room?.security_deposit_months ?? "N/A"}
//                 </p>

//                 <div className="room-details" style={{ paddingTop: "5px" }}>
//                   <p>
//                     <strong>Amenities:</strong>
//                   </p>
//                   <ul className="amenities-list">
//                     {room?.features?.map((item, i) => (
//                       <li key={i}>
//                         <img src={item?.icon} alt="" />
//                         {item?.feature_name}
//                       </li>
//                       // <li key={i}>{item?.feature_name}</li>
//                     ))}
//                   </ul>
//                 </div>
//               </div>

//               <div style={{ display: "flex", gap: "10px" }}>
//                 <button
//                   className="book-now-button"
//                   onClick={() => {
//                     // if (room.showModal) {

//                     // }
//                     setSelectedRoomType(room?.room_type_name);
//                     setIsModalOpen(true);
//                   }}
//                   style={{
//                     flex: 1,
//                     padding: "12px 0",
//                     border: "none",
//                     borderRadius: "8px",
//                     // backgroundColor: '#7065F0',
//                     backgroundColor: "var(--primary-color)",
//                     color: "white",
//                     cursor: "pointer",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     fontWeight: 600,
//                     boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
//                     transition: "background-color 0.3s ease",
//                     fontSize: "14px",
//                   }}
//                 >
//                   Book Now
//                 </button>
//                 <button
//                   className="book-now-button"
//                   // style={{ fontSize: "12px" }}
//                   // onClick={() => {
//                   //     setSelectedRoomType(room?.room_type_name);
//                   //     setIsModalOpen(true);
//                   // }}
//                   style={{
//                     flex: 1,
//                     padding: "12px 0",
//                     border: "none",
//                     borderRadius: "8px",
//                     backgroundColor: "#ededed",
//                     color: "var(--primary-color)",
//                     cursor: "pointer",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     fontWeight: 600,
//                     boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
//                     transition: "background-color 0.3s ease",
//                     fontSize: "14px",
//                   }}
//                   // onClick={() => {
//                   //     // if (room.showModal) {

//                   //     // }
//                   //     // setSelectedRoomType(room?.room_type_name);
//                   //     setIsModalOpen2(true);
//                   // }}
//                   onClick={() => handleRequestCallback(room)}
//                 >
//                   Request Call
//                 </button>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* {isModalOpen && (
//                     <div className="modal-overlay">
//                         <div className="modal-content">
//                             <h2>Book Your Room</h2>
//                             <form>
//                                 <label>
//                                     Select Room Type:
//                                     <select
//                                         required
//                                         value={selectedRoomType}
//                                         onChange={(e) => setSelectedRoomType(e.target.value)}
//                                     >
//                                         <option value="">-- Choose an option --</option>
//                                         {roomType.map((room, index) => (
//                                             <option key={index} value={room.room_type_name}>
//                                                 {room.room_type_name} Sharing
//                                             </option>
//                                         ))}
//                                     </select>

//                                 </label>

//                                          <div className="bill-summary">
//                                     <div className="bill-row">
//                                         <span>Payment Amount:</span>
//                                         <span>Rs. 10,000</span>
//                                     </div>
//                                     <div className="bill-row">
//                                         <span>GST (18%):</span>
//                                         <span>Rs. 1,800</span>
//                                     </div>
//                                     <div className="bill-row total">
//                                         <span>Total Payable:</span>
//                                         <span>Rs. 11,800</span>
//                                     </div>
//                                 </div>

//                                 <div className="modal-buttons">
//                                     <button
//                                         type="button"
//                                         className="cancel-button"
//                                         onClick={() => setIsModalOpen(false)}
//                                     >
//                                         Cancel
//                                     </button>
//                                     <div
//                                         className="pay-button"
//                                         onClick={() => navigate('/booking-success')}
//                                     >
//                                         Confirm
//                                     </div>
//                                 </div>
//                             </form>
//                         </div>
//                     </div>
//                 )} */}

//         {confirmModal && (
//           <div className="modal-overlay">
//             <div className="modal-content">
//               <div
//                 style={{
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "center",
//                 }}
//               >
//                 <img
//                   alt="Success"
//                   // src='https://george-fx.github.io/nuton_api/assets/images/08.png'
//                   // src={require("../assets/other/check.png")}
//                   src={require("../assets/other/checked.png")}
//                   // src="#"
//                   style={{ width: "30%", height: "auto", margin: "30px 0" }}
//                 />
//                 {/* <h2 style={{ textAlign: 'center', marginBottom: 10 }}>
//                                     Request Sent Successfully
//                                 </h2> */}
//                 <p
//                   style={{
//                     textAlign: "center",
//                     marginBottom: 10,
//                     lineHeight: "1.6",
//                     fontSize: "18px",
//                     fontWeight: "bold",
//                   }}
//                 >
//                   Your Booking Created Successfully!
//                 </p>
//                 <text.T14
//                   style={{
//                     whiteSpace: "pre-line",
//                     textAlign: "center",
//                   }}
//                 >
//                   Our team will contact you soon.
//                 </text.T14>
//                 <p
//                   style={{
//                     whiteSpace: "pre-line",
//                     textAlign: "center",
//                     margin: "10px 0",
//                     color: "blue",
//                     fontSize: "14px",
//                     textDecoration: "underline",
//                   }}
//                   onClick={() => navigate("/my-booking")}
//                 >
//                   View Booking
//                 </p>
//                 <div
//                   onClick={() => {
//                     setConfirmModal(false);
//                   }}
//                   style={{
//                     width: "100%",
//                     color: theme.colors.white,
//                     height: 40,
//                     textAlign: "center",
//                     fontSize: 14,
//                     borderRadius: 10,
//                     userSelect: "none",
//                     cursor: "pointer",
//                     textTransform: "capitalize",
//                     // background: "#000000d1",
//                     background: "var(--primary-color)",
//                     fontFamily: "Lato-Bold",
//                     marginTop: 12, // optional spacing
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                   }}
//                 >
//                   Continue
//                 </div>
//               </div>
//               {/* <div className="modal-buttons">
//                                 <button
//                                     type="button"
//                                     className="cancel-button"
//                                     onClick={() => setIsModalOpen2(false)}
//                                 >
//                                     Thank You
//                                 </button>
//                             </div> */}
//             </div>
//           </div>
//         )}

//         {isModalOpen && (
//           <div className="modal-overlay">
//             <div className="modal-content">
//               <h2>Book Now</h2>
//               <form
//                 onSubmit={(e) => {
//                   e.preventDefault();
//                   handleSubmitTenant();
//                 }}
//               >
//                 <label className="form-label">
//                   <span style={{ fontWeight: "bold" }}>Full Name:</span>

//                   <input
//                     type="text"
//                     name="fullName"
//                     placeholder="Name"
//                     value={formData.fullName}
//                     onChange={handleChange}
//                   />
//                 </label>

//                 {/* Update Gender */}

//                 {/*
//                                               <div className="form-group" style={{ marginBottom: "0px" }}>
//                                     <label
//                                         className="form-label"
//                                         style={{
//                                             display: "block",
//                                             marginBottom: "0.5rem",
//                                             fontWeight: "bold",
//                                             fontSize: "14px",
//                                         }}
//                                     >
//                                         Gender
//                                     </label>

//                                     <div
//                                         className="radio-group"
//                                         style={{
//                                             display: "flex",
//                                             gap: "24px",
//                                             alignItems: "center",
//                                             padding: "4px 0",
//                                         }}
//                                     >
//                                         {[
//                                             { label: "Male", value: "GENDER_MALE" },
//                                             { label: "Female", value: "GENDER_FEMALE" },
//                                             { label: "Other", value: "GENDER_OTHER" },
//                                         ].map(({ label, value }) => (
//                                             <label
//                                                 key={value}
//                                                 style={{
//                                                     display: "flex",
//                                                     alignItems: "center",
//                                                     gap: "8px",
//                                                     fontSize: "14px",
//                                                     lineHeight: "1.5",
//                                                     cursor: "pointer",
//                                                 }}
//                                             >
//                                                 <input
//                                                     type="radio"
//                                                     name="gender"
//                                                     value={value}
//                                                     checked={formData.gender === value}
//                                                     onChange={(e) =>
//                                                         setFormData((prev) => ({ ...prev, gender: e.target.value }))
//                                                     }
//                                                     style={{ margin: "0" }}
//                                                 />
//                                                 {label}
//                                             </label>
//                                         ))}
//                                     </div>

//                                 </div>
//                                 */}

//                 {/* 🧍‍♂️ Gender Selection UI */}
//                 <div className="form-group" style={{ marginBottom: "0px" }}>
//                   <label
//                     className="form-label"
//                     style={{
//                       display: "block",
//                       marginBottom: "0.5rem",
//                       fontWeight: "bold",
//                       fontSize: "14px",
//                     }}
//                   >
//                     Gender
//                   </label>

//                   <div
//                     className="radio-group"
//                     style={{
//                       display: "flex",
//                       gap: "24px",
//                       alignItems: "center",
//                       padding: "4px 0",
//                     }}
//                   >
//                     {genderOptions.map(({ label, value }) => (
//                       <label
//                         key={value}
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: "8px",
//                           fontSize: "14px",
//                           lineHeight: "1.5",
//                           cursor: "pointer",
//                         }}
//                       >
//                         <input
//                           type="radio"
//                           name="gender"
//                           value={value}
//                           checked={formData.gender === value}
//                           onChange={(e) =>
//                             setFormData((prev) => ({
//                               ...prev,
//                               gender: e.target.value,
//                             }))
//                           }
//                           style={{ margin: "0", accentColor: "#014d4e" }}
//                         />
//                         {label}
//                       </label>
//                     ))}
//                   </div>
//                 </div>

//                 {/* Contact Number */}
//                 <div className="form-group" style={{ marginBottom: "1rem" }}>
//                   <label
//                     htmlFor="contactNumber"
//                     className="form-label"
//                     style={{
//                       display: "block",
//                       marginBottom: "0.5rem",
//                       fontWeight: "bold",
//                     }}
//                   >
//                     Contact Number:
//                   </label>
//                   <div
//                     style={{
//                       display: "flex",
//                       gap: "8px",
//                       alignItems: "center",
//                     }}
//                   >
//                     <input
//                       type="tel"
//                       name="contact_number"
//                       placeholder="Phone number"
//                       value={formData.contact_number}
//                       onChange={(e) => {
//                         const value = e.target.value;
//                         // Allow only digits and up to 10 characters
//                         if (/^\d{0,10}$/.test(value)) {
//                           setFormData({ ...formData, contact_number: value });
//                         }
//                       }}
//                       maxLength={10}
//                       style={{
//                         padding: "0.5rem",
//                         border: "1px solid #ccc",
//                         borderRadius: "4px",
//                       }}
//                       // readOnly
//                       disabled
//                     />
//                   </div>
//                 </div>

//                 <label>
//                   <span className="form-label" style={{ fontWeight: "bold" }}>
//                     Email:
//                   </span>
//                   <input
//                     type="text"
//                     placeholder="Email"
//                     name="email"
//                     value={formData.email}
//                     onChange={handleChange}
//                   />
//                 </label>
//                 <label
//                   className="form-label"
//                   style={{
//                     display: "block",
//                     marginBottom: "1rem",
//                     fontWeight: "bold",
//                   }}
//                 >
//                   Occupation:
//                   <select
//                     name="occupation"
//                     value={formData.occupation}
//                     onChange={handleChange}
//                     style={{
//                       display: "block",
//                       marginTop: "0.5rem",
//                       padding: "0.5rem",
//                       width: "100%",
//                       border: "1px solid #ccc",
//                       borderRadius: "4px",
//                     }}
//                     // required
//                   >
//                     <option value="">Select Occupation</option>
//                     <option value="Student">Student</option>
//                     <option value="Working">Working</option>
//                     {/* <option value="business">Business</option>
//                                         <option value="freelancer">Freelancer</option>
//                                         <option value="other">Other</option> */}
//                   </select>
//                 </label>

//                 {/* B2B User */}
//                 {/* <div className="form-group">
//                   <label
//                     className="form-label"
//                     style={{ fontWeight: "bold", fontSize: "14px" }}
//                   >
//                     Are you a B2B user?
//                   </label>
//                   <div
//                     className="radio-group"
//                     style={{
//                       display: "flex",
//                       gap: "24px",
//                       alignItems: "center",
//                     }}
//                   >
//                     {["Yes", "No"].map((value) => (
//                       <label
//                         key={value}
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: "8px",
//                           fontSize: "14px",
//                           cursor: "pointer",
//                         }}
//                       >
//                         <input
//                           type="radio"
//                           name="is_b2b_user"
//                           value={value}
//                           checked={formData.is_b2b_user === value}
//                           onChange={handleChange}
//                           style={{ margin: "0", accentColor: "#014d4e" }}
//                         />
//                         {value}
//                       </label>
//                     ))}
//                   </div>
//                 </div> */}

//                 <div className="modal-buttons">
//                   <button
//                     type="button"
//                     className="cancel-button"
//                     onClick={() => setIsModalOpen(false)}
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="submit"
//                     className="pay-button"
//                     // onClick={handleSubmitTenant}
//                     disabled={submitLoading}
//                   >
//                     {submitLoading ? "Submitting..." : "Submit"}
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         )}

//         {isModalOpenDate && (
//           <div className="modal-overlay">
//             <div className="modal-content">
//               <h2>Select Date </h2>
//               <form
//                 onSubmit={(e) => {
//                   e.preventDefault();
//                   handleAgreementSubmit(agreementDate);
//                   callLeadServiceAPI();
//                 }}
//               >
//                 {/* <input
//                     type="date"
//                     value={agreementDate}
//                     onChange={(e) => setAgreementDate(e.target.value)}
//                     required
//                 /> */}
//                 <input
//                   type="date"
//                   placeholder="Select date"
//                   value={agreementDate}
//                   onChange={(e) => setAgreementDate(e.target.value)}
//                   min={getTomorrowDate()}
//                   onClick={(e: any) => e.currentTarget.showPicker?.()}
//                   required
//                 />

//                 <div
//                   className="modal-buttons"
//                   style={{
//                     display: "flex",
//                     justifyContent: "flex-end",
//                     gap: "10px",
//                     marginTop: "1rem",
//                   }}
//                 >
//                   <button
//                     type="button"
//                     className="cancel-button"
//                     onClick={() => setIsModalOpenDate(false)} // 👈 closes the date modal
//                     style={{
//                       padding: "0.5rem 1rem",
//                       backgroundColor: "#e0e0e0",
//                       border: "1px solid #ccc",
//                       borderRadius: "4px",
//                       cursor: "pointer",
//                     }}
//                   >
//                     Cancel
//                   </button>

//                   <button
//                     type="submit" // 👈 allows it to submit the form
//                     className="pay-button"
//                     disabled={AgreementAllotedLoading}
//                     style={{
//                       padding: "0.5rem 1rem",
//                       // backgroundColor: "#4CAF50",
//                       backgroundColor: "var(--primary-color)",
//                       color: "white",
//                       border: "none",
//                       borderRadius: "4px",
//                       cursor: "pointer",
//                     }}
//                   >
//                     {AgreementAllotedLoading ? "Submitting..." : "Submit"}
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         )}

//         {/* {isModalOpen2 && (
//                     <div className="modal-overlay">
//                         <div className="modal-content">
//                             <h2>Requst A Call Back</h2>
//                             <form>
//                                 <label>
//                                     Name:
//                                     <input type="text" placeholder="name" />
//                                 </label>
//                                 <label>
//                                     Phon No:
//                                     <input type="text" placeholder="phon no" />
//                                 </label>

//                                 <label style={{ display: "block", marginBottom: "1rem" }}>
//                                     Description:
//                                     <textarea
//                                         name="description"
//                                         placeholder="Write your message or query here"
//                                         rows={6}
//                                         // rows="4"
//                                         required
//                                         style={{
//                                             width: "100%",
//                                             padding: "0.5rem",
//                                             marginTop: "0.3rem",
//                                             border: "1px solid #ccc",
//                                             borderRadius: "4px",
//                                             resize: "vertical",
//                                             fontSize: "14px",
//                                         }}
//                                     ></textarea>
//                                 </label>

//                                 <div className="modal-buttons">
//                                     <button
//                                         type="button"
//                                         className="cancel-button"
//                                         onClick={() => setIsModalOpen2(false)}
//                                     >
//                                         Cancel
//                                     </button>
//                                     <div
//                                         className="pay-button"

//                                     >
//                                         Submit
//                                     </div>
//                                 </div>
//                             </form>
//                         </div>
//                     </div>
//                 )} */}

//         {isModalOpen2 && (
//           <div className="modal-overlay">
//             <div className="modal-content">
//               <h2></h2>
//               <p></p>
//               <div
//                 style={{
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "center",
//                 }}
//               >
//                 <img
//                   alt="Success"
//                   src={require("../assets/nestfin/Nestfin_logo.png")}
//                   style={{ width: "50%", height: "auto", marginBottom: 10 }}
//                 />
//                 {/* <span
//                                                     style={{
//                                                         ...theme.fonts.LeagueSpartan_500Medium,
//                                                         fontSize: 12,
//                                                         color: theme.colors.mainColor,
//                                                     }}
//                                                 >
//                                                     Nuton
//                                                 </span> */}
//                 <img
//                   alt="Success"
//                   // src='https://george-fx.github.io/nuton_api/assets/images/08.png'
//                   src={require("../assets/other/checked.png")}
//                   style={{ width: "30%", height: "auto", margin: "30px 0" }}
//                 />
//                 <h2 style={{ textAlign: "center", marginBottom: 10 }}>
//
//                 </h2>
//                 <text.T16
//                   style={{
//                     whiteSpace: "pre-line",
//                     textAlign: "center",
//                     marginBottom: 24,
//                   }}
//                 >
//                   Thank you! Our team will get in touch with you shortly.
//                 </text.T16>

//                 {/* <components.Button
//                                                     title='Continue'
//                                                     onClick={() => {
//                                                         navigate('/tab-navigator');
//                                                     }}
//                                                 /> */}

//                 <div
//                   onClick={() => {
//                     setIsModalOpen2(false);
//                   }}
//                   style={{
//                     width: "100%",
//                     color: theme.colors.white,
//                     height: 40,
//                     textAlign: "center",
//                     fontSize: 14,
//                     borderRadius: 10,
//                     userSelect: "none",
//                     cursor: "pointer",
//                     textTransform: "capitalize",
//                     background: "#000000d1",
//                     fontFamily: "Lato-Bold",
//                     marginTop: 12, // optional spacing
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                   }}
//                 >
//                   Continue
//                 </div>
//               </div>
//               {/* <div className="modal-buttons">
//                                 <button
//                                     type="button"
//                                     className="cancel-button"
//                                     onClick={() => setIsModalOpen2(false)}
//                                 >
//                                     Thank You
//                                 </button>

//                             </div> */}
//             </div>
//           </div>
//         )}

//         {isModalOpen3 && (
//           <div className="modal-overlay">
//             <div className="modal-content">
//               <div
//                 style={{
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "center",
//                 }}
//               >
//                 <img
//                   alt="Success"
//                   src={require("../assets/nestfin/Nestfin_logo.png")}
//                   style={{ width: "50%", height: "auto", marginBottom: 10 }}
//                 />
//                 {/* <span
//                                                                                     style={{
//                                                                                         ...theme.fonts.LeagueSpartan_500Medium,
//                                                                                         fontSize: 12,
//                                                                                         color: theme.colors.mainColor,
//                                                                                     }}
//                                                                                 >
//                                                                                     Nuton
//                                                                                 </span> */}
//                 <img
//                   alt="Success"
//                   // src='https://george-fx.github.io/nuton_api/assets/images/08.png'
//                   src={require("../assets/other/warning2.png")}
//                   style={{ width: "25%", height: "auto", margin: "30px 0" }}
//                 />
//                 <h2 style={{ textAlign: "center", marginBottom: 10 }}>
//                   Something Went Wrong
//                 </h2>
//                 <p
//                   style={{
//                     textAlign: "center",
//                     marginBottom: 10,
//                     lineHeight: "1.6",
//                   }}
//                 >
//                   We couldn't process your request.
//                 </p>
//                 <text.T14
//                   style={{
//                     whiteSpace: "pre-line",
//                     textAlign: "center",
//                     marginBottom: 24,
//                   }}
//                 >
//                   Please try again later. If the issue persists, contact our
//                   support team.
//                 </text.T14>
//                 <div
//                   onClick={() => {
//                     setIsModalOpen3(false);
//                   }}
//                   style={{
//                     width: "100%",
//                     color: theme.colors.white,
//                     height: 40,
//                     textAlign: "center",
//                     fontSize: 14,
//                     borderRadius: 10,
//                     userSelect: "none",
//                     cursor: "pointer",
//                     textTransform: "capitalize",
//                     // background: "#000000d1",
//                     background: "#000000d1",
//                     fontFamily: "Lato-Bold",
//                     marginTop: 12, // optional spacing
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                   }}
//                 >
//                   Continue
//                 </div>
//               </div>
//               {/* <div className="modal-buttons">
//                                                                 <button
//                                                                     type="button"
//                                                                     className="cancel-button"
//                                                                     onClick={() => setIsModalOpen2(false)}
//                                                                 >
//                                                                     Thank You
//                                                                 </button>

//                                                             </div> */}
//             </div>
//           </div>
//         )}
//       </div>
//     );
//   };

//   const renderContent = (): JSX.Element => {
//     return (
//       <main>
//         {renderTitle()}
//         {renderCards()}
//         {/* {renderSearchBar2()}
//                 {offerBanner()}
//                 {serachResult()} */}
//       </main>
//     );
//   };

//   return (
//     <>
//       {renderHeader()}
//       {renderContent()}
//       {renderBottomTabBar()}
//     </>
//   );
// };

// #########################################------------------ old code #####################################------

// import axios from "axios";
// import { Swiper, SwiperSlide } from "swiper/react";
// import React, { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import useEmblaCarousel from "embla-carousel-react";
// import { components } from "../components";
// // import logo from "../../assets/nestfin/NexfinPng.png"
// import logo from "../assets/nestfin/NexfinPng.png"
// import { BottomTabBar } from "../navigation/BottomTabBar";
// import { text } from '../text';
// import { hooks } from "../hooks";
// import roomAvailable from '../assets/nestfin/deadline.png'
// import cash from '../assets/nestfin/cash.png'
// import { PropertyRoomType, Feature } from '../../src/types/types'
// import { getRoomOptionsById } from "../environment";
// import useApi from "../customHook/useApi";

// export interface APIResponse {
//     success: boolean;
//     statusCode: number;
//     data: PropertyRoomType[];
//     message: string;
// }

// export const RoomDetails: React.FC = () => {

//     const [isModalOpen, setIsModalOpen] = useState(false);
//     const location = useLocation();
//     const navigate = hooks.useNavigate();
//     const [selectedRoomType, setSelectedRoomType] = useState("");
//     const [roomType, setRoomType] = useState<PropertyRoomType[]>([])

//     useEffect(() => {
//         window.scrollTo(0, 0);
//     }, []);

//     // API CALL
//     const {
//         data: propertyRoomDetailData,
//         loading: propertyRoomDetailLoading,
//         callApi: fetchPropertyRoomDetail,
//     } = useApi<APIResponse>(getRoomOptionsById, {
//         method: "POST",
//         autoCall: false,
//         dependencies: [],
//     });

//     useEffect(() => {

//         fetchPropertyRoomDetail({
//             // leadId: leadId,
//             // propertyId: propertyId,
//             leadId: "LEAD-B-2025-05-001",
//             propertyId: "PR-G-2025-05-072",
//         });

//     }, [location.state])

//     useEffect(() => {
//         if (propertyRoomDetailData?.data) {
//             console.log("✅ propertyRoomDetailData received:", propertyRoomDetailData?.data);
//             setRoomType(propertyRoomDetailData?.data)
//         }
//     }, [propertyRoomDetailData]);

//     // Start Component
//     const renderHeader = (): JSX.Element => {
//         return (
//             <components.Header
//                 goBack={false}
//                 line={false}
//                 leftlogo={true}
//                    rightlogo={false}
//                 // search={true}
//                 filter={false}
//                 // logo={true}
//                 title={""}

//                 centerImageSrc={logo}

//             />
//         );
//     };

//     const renderBottomTabBar = (): JSX.Element => {
//         return <BottomTabBar />;
//     };

//     const renderTitle = (): JSX.Element => {
//         return (
//             <div className='container propertiesDetails' style={{ marginTop: "20px" }}>
//                 <text.H4
//                     style={{ marginBottom: 6, textAlign: "center" }}
//                     numberOfLines={2}
//                 >
//                     Discover Affordable Living at StayNest
//                 </text.H4>
//             </div>
//         );
//     };
//     const rooms = [
//         {
//             title: "Single Sharing",
//             subtitle: "(Balcony View Room)",
//             price: "₹12,000/bed",
//             availability: "Only 5 Rooms Left",
//             deposit: "2 Months",
//             amenities: [
//                 'Balcony',
//                 'Natural Light',
//                 'Air Conditioning',
//             ],
//             showModal: true,
//         },
//         {
//             title: "Double Sharing",
//             subtitle: "(With Food)",
//             price: "₹8,000/bed",
//             availability: "Only 3 Rooms Left",
//             deposit: "2 Months",
//             amenities: [
//                 'Shared Kitchen',
//                 'Wi-Fi',
//                 'LED TV',
//                 'Curtains for Privacy',
//             ],
//             showModal: true,
//         },
//         {
//             title: "Triple Sharing",
//             subtitle: "(With Food)",
//             price: "₹6,000/bed",
//             availability: "Only 4 Rooms Left",
//             deposit: "2 Months",
//             amenities: [
//                 'Common Area Access',
//                 'CCTV Surveillance',
//                 'Security Guard',
//                 'Study Table & Chair',
//                 'Fridge (Shared)',
//             ],
//             showModal: true,
//         }
//     ];

//     const renderCards = (): JSX.Element => {
//         return (
//             <div style={{ display: "flex", justifyContent: "center" }}>
//                 <div style={{ display: "flex", flexWrap: "wrap", gap: "0px", justifyContent: "center" }}>
//                     {rooms.map((room, index) => (
//                         <div className="room-card" key={index}>
//                             <div className="room-card-header">
//                                 <h2 className="room-title">
//                                     {room.title} <div>{room.subtitle}</div>
//                                 </h2>
//                                 <p className="room-price">{room.price}</p>
//                             </div>

//                             <div className="room-details">
//                                 <p>
//                                     <img
//                                         src={roomAvailable}
//                                         alt="Room Available"
//                                         className="availability-icon"
//                                     />
//                                     <strong> Availability:</strong> {room.availability}
//                                 </p>
//                                 <p> <img
//                                     src={cash}
//                                     alt="Room Available"
//                                     className="availability-icon"
//                                 /> <strong>Security Deposit:</strong> {room.deposit}</p>

//                                 <div className="room-details" style={{ paddingTop: "5px" }}>
//                                     <p><strong>Amenities:</strong></p>
//                                     <ul className="amenities-list">
//                                         {room.amenities.map((item, i) => (
//                                             <li key={i}>{item}</li>
//                                         ))}
//                                     </ul>
//                                 </div>
//                             </div>

//                             <button
//                                 className="book-now-button"
//                                 onClick={() => {
//                                     if (room.showModal) {
//                                         setSelectedRoomType(room.title);
//                                         setIsModalOpen(true);
//                                     }
//                                 }}
//                             >
//                                 Book Now
//                             </button>
//                         </div>
//                     ))}
//                 </div>

//                 {isModalOpen && (
//                     <div className="modal-overlay">
//                         <div className="modal-content">
//                             <h2>Book Your Room</h2>
//                             <form>
//                                 <label>
//                                     Select Room Type:
//                                     <select
//                                         required
//                                         value={selectedRoomType}
//                                         onChange={(e) => setSelectedRoomType(e.target.value)}
//                                     >
//                                         <option value="">-- Choose an option --</option>
//                                         <option value="Triple Sharing">Triple Sharing</option>
//                                         <option value="Single Sharing">Single Sharing</option>
//                                         <option value="Double Sharing">Double Sharing</option>
//                                         <option value="Private">Private</option>
//                                     </select>
//                                 </label>

//                                 {/* Bill Summary */}
//                                 <div className="bill-summary">
//                                     <div className="bill-row">
//                                         <span>Payment Amount:</span>
//                                         <span>Rs. 10,000</span>
//                                     </div>
//                                     <div className="bill-row">
//                                         <span>GST (18%):</span>
//                                         <span>Rs. 1,800</span>
//                                     </div>
//                                     <div className="bill-row total">
//                                         <span>Total Payable:</span>
//                                         <span>Rs. 11,800</span>
//                                     </div>
//                                 </div>

//                                 <div className="modal-buttons">
//                                     <button
//                                         type="button"
//                                         className="cancel-button"
//                                         onClick={() => setIsModalOpen(false)}
//                                     >
//                                         Cancel
//                                     </button>
//                                     <div
//                                         className="pay-button"
//                                         onClick={() => navigate('/booking-success')}
//                                     >
//                                         Confirm
//                                     </div>
//                                 </div>
//                             </form>
//                         </div>
//                     </div>
//                 )}

//             </div>
//         );
//     };

//     const renderContent = (): JSX.Element => {
//         return (
//             <main >
//                 {renderTitle()}
//                 {renderCards()}
//                 {/* {renderSearchBar2()}
//                 {offerBanner()}
//                 {serachResult()} */}
//             </main >
//         );
//     };

//     return (
//         <>
//             {renderHeader()}
//             {renderContent()}
//             {renderBottomTabBar()}
//         </>
//     );
// };

// import axios from "axios";
// import { Swiper, SwiperSlide } from "swiper/react";
// import React, { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import useEmblaCarousel from "embla-carousel-react";
// import { components } from "../components";
// // import logo from "../../assets/nestfin/NexfinPng.png"
// import logo from "../assets/nestfin/NexfinPng.png"
// import { BottomTabBar } from "../navigation/BottomTabBar";
// import { text } from '../text';
// import { hooks } from "../hooks";
// import roomAvailable from '../assets/nestfin/deadline.png'
// import cash from '../assets/nestfin/cash.png'
// import { PropertyRoomType, Feature } from '../../src/types/types'
// import { getRoomOptionsById } from "../environment";
// import useApi from "../customHook/useApi";

// export interface APIResponse {
//     success: boolean;
//     statusCode: number;
//     data: PropertyRoomType[];
//     message: string;
// }

// export const RoomDetails: React.FC = () => {

//     const [isModalOpen, setIsModalOpen] = useState(false);
//     const location = useLocation();
//     const navigate = hooks.useNavigate();
//     const [selectedRoomType, setSelectedRoomType] = useState("");

//     useEffect(() => {
//         window.scrollTo(0, 0);
//     }, []);

//     // API CALL
//     const {
//         data: propertyRoomDetailData,
//         loading: propertyRoomDetailLoading,
//         callApi: fetchPropertyRoomDetail,
//     } = useApi<APIResponse>(getRoomOptionsById, {
//         method: "POST",
//         autoCall: false,
//         dependencies: [],
//     });

//     useEffect(() => {

//         fetchPropertyRoomDetail({
//             // leadId: leadId,
//             // propertyId: propertyId,
//             leadId: "LEAD-B-2025-05-001",
//             propertyId: "PR-G-2025-05-072",
//         });

//     }, [location.state])

//     useEffect(() => {
//         console.log(propertyRoomDetailData?.data, "propertyRoomDetailData........");

//     }, [propertyRoomDetailData])

//     // Start Component
//     const renderHeader = (): JSX.Element => {
//         return (
//             <components.Header
//                 goBack={false}
//                 line={false}
//                 leftlogo={true}
//                    rightlogo={false}
//                 // search={true}
//                 filter={false}
//                 // logo={true}
//                 title={""}

//                 centerImageSrc={logo}

//             />
//         );
//     };

//     const renderBottomTabBar = (): JSX.Element => {
//         return <BottomTabBar />;
//     };

//     const renderTitle = (): JSX.Element => {
//         return (
//             <div className='container propertiesDetails' style={{ marginTop: "20px" }}>
//                 <text.H4
//                     style={{ marginBottom: 6, textAlign: "center" }}
//                     numberOfLines={2}
//                 >
//                     Discover Affordable Living at StayNest
//                 </text.H4>
//             </div>
//         );
//     };
//     const rooms = [
//         {
//             title: "Single Sharing",
//             subtitle: "(Balcony View Room)",
//             price: "₹12,000/bed",
//             availability: "Only 5 Rooms Left",
//             deposit: "2 Months",
//             amenities: [
//                 'Balcony',
//                 'Natural Light',
//                 'Air Conditioning',
//             ],
//             showModal: true,
//         },
//         {
//             title: "Double Sharing",
//             subtitle: "(With Food)",
//             price: "₹8,000/bed",
//             availability: "Only 3 Rooms Left",
//             deposit: "2 Months",
//             amenities: [
//                 'Shared Kitchen',
//                 'Wi-Fi',
//                 'LED TV',
//                 'Curtains for Privacy',
//             ],
//             showModal: true,
//         },
//         {
//             title: "Triple Sharing",
//             subtitle: "(With Food)",
//             price: "₹6,000/bed",
//             availability: "Only 4 Rooms Left",
//             deposit: "2 Months",
//             amenities: [
//                 'Common Area Access',
//                 'CCTV Surveillance',
//                 'Security Guard',
//                 'Study Table & Chair',
//                 'Fridge (Shared)',
//             ],
//             showModal: true,
//         }
//     ];

//     const renderCards = (): JSX.Element => {
//         return (
//             <div style={{ display: "flex", justifyContent: "center" }}>
//                 <div style={{ display: "flex", flexWrap: "wrap", gap: "0px", justifyContent: "center" }}>
//                     {rooms.map((room, index) => (
//                         <div className="room-card" key={index}>
//                             <div className="room-card-header">
//                                 <h2 className="room-title">
//                                     {room.title} <div>{room.subtitle}</div>
//                                 </h2>
//                                 <p className="room-price">{room.price}</p>
//                             </div>

//                             <div className="room-details">
//                                 <p>
//                                     <img
//                                         src={roomAvailable}
//                                         alt="Room Available"
//                                         className="availability-icon"
//                                     />
//                                     <strong> Availability:</strong> {room.availability}
//                                 </p>
//                                 <p> <img
//                                     src={cash}
//                                     alt="Room Available"
//                                     className="availability-icon"
//                                 /> <strong>Security Deposit:</strong> {room.deposit}</p>

//                                 <div className="room-details" style={{ paddingTop: "5px" }}>
//                                     <p><strong>Amenities:</strong></p>
//                                     <ul className="amenities-list">
//                                         {room.amenities.map((item, i) => (
//                                             <li key={i}>{item}</li>
//                                         ))}
//                                     </ul>
//                                 </div>
//                             </div>

//                             <button
//                                 className="book-now-button"
//                                 onClick={() => {
//                                     if (room.showModal) {
//                                         setSelectedRoomType(room.title);
//                                         setIsModalOpen(true);
//                                     }
//                                 }}
//                             >
//                                 Book Now
//                             </button>
//                         </div>
//                     ))}
//                 </div>

//                 {/* {isModalOpen && (
//                     <div className="modal-overlay">
//                         <div className="modal-content">
//                             <h2>Book Your Room </h2>
//                             <form>
//                                 <label>
//                                     Select Room Type:
//                                     <select
//                                         required
//                                         value={selectedRoomType}
//                                         onChange={(e) => setSelectedRoomType(e.target.value)}
//                                     >
//                                         <option value="">-- Choose an option --</option>
//                                         <option value="Triple Sharing">Triple Sharing</option>
//                                         <option value="Single Sharing">Single Sharing</option>
//                                         <option value="Double Sharing">Double Sharing</option>
//                                         <option value="Private">Private</option>
//                                     </select>

//                                 </label>

//                                 <label>
//                                     Payment Amount:
//                                     <input type="text" value="Rs. 10,000" readOnly />
//                                 </label>

//                                 <label>
//                                     GST (18%):
//                                     <input type="text" value="Rs. 1,800" readOnly />
//                                 </label>

//                                 <label>
//                                     Total Payable:
//                                     <input type="text" value="Rs. 11,800" readOnly />
//                                 </label>

//                                 <div className="modal-buttons">
//                                     <button
//                                         type="button"
//                                         className="cancel-button"
//                                         onClick={() => setIsModalOpen(false)}
//                                     >
//                                         Cancel
//                                     </button>
//                                     <div
//                                         className="pay-button"
//                                         onClick={() => navigate('/choose-payment-method')}
//                                     >
//                                         Confirm
//                                     </div>
//                                 </div>
//                             </form>
//                         </div>
//                     </div>
//                 )} */}
//                 {isModalOpen && (
//                     <div className="modal-overlay">
//                         <div className="modal-content">
//                             <h2>Book Your Room</h2>
//                             <form>
//                                 <label>
//                                     Select Room Type:
//                                     <select
//                                         required
//                                         value={selectedRoomType}
//                                         onChange={(e) => setSelectedRoomType(e.target.value)}
//                                     >
//                                         <option value="">-- Choose an option --</option>
//                                         <option value="Triple Sharing">Triple Sharing</option>
//                                         <option value="Single Sharing">Single Sharing</option>
//                                         <option value="Double Sharing">Double Sharing</option>
//                                         <option value="Private">Private</option>
//                                     </select>
//                                 </label>

//                                 {/* Bill Summary */}
//                                 <div className="bill-summary">
//                                     <div className="bill-row">
//                                         <span>Payment Amount:</span>
//                                         <span>Rs. 10,000</span>
//                                     </div>
//                                     <div className="bill-row">
//                                         <span>GST (18%):</span>
//                                         <span>Rs. 1,800</span>
//                                     </div>
//                                     <div className="bill-row total">
//                                         <span>Total Payable:</span>
//                                         <span>Rs. 11,800</span>
//                                     </div>
//                                 </div>

//                                 <div className="modal-buttons">
//                                     <button
//                                         type="button"
//                                         className="cancel-button"
//                                         onClick={() => setIsModalOpen(false)}
//                                     >
//                                         Cancel
//                                     </button>
//                                     <div
//                                         className="pay-button"
//                                         onClick={() => navigate('/booking-success')}
//                                     >
//                                         Confirm
//                                     </div>
//                                 </div>
//                             </form>
//                         </div>
//                     </div>
//                 )}

//             </div>
//         );
//     };

//     // const renderCards = (): JSX.Element => {
//     //     // const amenities = [
//     //     //     'Balcony',
//     //     //     'Natural Light',
//     //     //     'Air Conditioning',
//     //     //     'Wi-Fi',
//     //     //     'Housekeeping',
//     //     //     'Shared Kitchen',
//     //     //     'Laundry Service',
//     //     //     'Private Wardrobe',
//     //     //     'Study Table & Chair',
//     //     //     'Attached Bathroom',
//     //     //     'Geyser/Water Heater',
//     //     //     '24/7 Water Supply',
//     //     //     'Power Backup',
//     //     //     'LED TV',
//     //     //     'Common Area Access',
//     //     //     'CCTV Surveillance',
//     //     //     'Security Guard',
//     //     //     'Fridge (Shared)',
//     //     //     'Mattress & Bedding',
//     //     //     'Curtains for Privacy'
//     //     // ];
//     //     const amenities = [
//     //         'Balcony',
//     //         'Natural Light',
//     //         'Air Conditioning',
//     //         'Wi-Fi',
//     //         'Housekeeping',];

//     //     return (
//     //         <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
//     //             <div className="room-card">
//     //                 <div className="room-card-header">
//     //                     <h2 className="room-title">
//     //                         Single Sharing <div>(Balcony View Room)</div>
//     //                     </h2>
//     //                     <p className="room-price">₹12,000/bed</p>
//     //                 </div>

//     //                 <div className="room-details">
//     //                     <p><i className="fa fa-door-open"></i> <strong>Availability:</strong> 2 Rooms Left</p>
//     //                     <p><i className="fa fa-shield-alt"></i> <strong>Security Deposit:</strong> 2 Months</p>

//     //                     <div className="room-details" style={{ paddingTop: "5px" }}>
//     //                         <p><strong>Amenities:</strong></p>
//     //                         <ul className="amenities-list">
//     //                             {amenities.map((item, index) => (
//     //                                 <li key={index}>{item}</li>
//     //                             ))}
//     //                         </ul>
//     //                     </div>
//     //                 </div>

//     //                 <button className="book-now-button">Book Now</button>
//     //             </div>
//     //             <div className="room-card">
//     //                 <div className="room-card-header">
//     //                     <h2 className="room-title">
//     //                         Dobule Sharing <div>(With Food)</div>
//     //                     </h2>
//     //                     <p className="room-price">₹8,000/bed</p>
//     //                 </div>

//     //                 <div className="room-details">
//     //                     <p><i className="fa fa-door-open"></i> <strong>Availability:</strong> 2 Rooms Left</p>
//     //                     <p><i className="fa fa-shield-alt"></i> <strong>Security Deposit:</strong> 2 Months</p>

//     //                     <div className="room-details" style={{ paddingTop: "5px" }}>
//     //                         <p><strong>Amenities:</strong></p>
//     //                         <ul className="amenities-list">
//     //                             {amenities.map((item, index) => (
//     //                                 <li key={index}>{item}</li>
//     //                             ))}
//     //                         </ul>
//     //                     </div>
//     //                 </div>

//     //                 <button className="book-now-button" onClick={() => setIsModalOpen(true)}>Book Now</button>
//     //             </div>
//     //             {isModalOpen && (
//     //                 <div className="modal-overlay">
//     //                     <div className="modal-content">
//     //                         <h2>Book Your Room</h2>
//     //                         <form>
//     //                             <label>
//     //                                 Select Room Type:
//     //                                 <select required>
//     //                                     <option value="">-- Choose an option --</option>
//     //                                     <option value="multi">Multi Sharing</option>
//     //                                     <option value="single">Single Sharing</option>
//     //                                     <option value="double">Double Sharing</option>
//     //                                     <option value="private">Private</option>
//     //                                 </select>
//     //                             </label>

//     //                             <label>
//     //                                 Payment Amount:
//     //                                 <input type="text" value="Rs. 10,000" readOnly />
//     //                             </label>

//     //                             <label>
//     //                                 GST (18%):
//     //                                 <input type="text" value="Rs. 1,800" readOnly />
//     //                             </label>

//     //                             <label>
//     //                                 Total Payable:
//     //                                 <input type="text" value="Rs. 11,800" readOnly />
//     //                             </label>

//     //                             <div className="modal-buttons">
//     //                                 <button
//     //                                     type="button"
//     //                                     className="cancel-button"
//     //                                     onClick={() => setIsModalOpen(false)}
//     //                                 >
//     //                                     Cancel
//     //                                 </button>
//     //                                 <div className="pay-button"
//     //                                     onClick={() => navigate('/choose-payment-method')}
//     //                                 >Confirm</div>
//     //                             </div>
//     //                         </form>
//     //                     </div>
//     //                 </div>
//     //             )}
//     //         </div>
//     //     );
//     // };

//     const renderContent = (): JSX.Element => {
//         return (
//             <main >
//                 {renderTitle()}
//                 {renderCards()}
//                 {/* {renderSearchBar2()}
//                 {offerBanner()}
//                 {serachResult()} */}
//             </main >
//         );
//     };

//     return (
//         <>
//             {renderHeader()}
//             {renderContent()}
//             {renderBottomTabBar()}
//         </>
//     );
// };
